<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
        Transferência
        {{
          tipoTransferencia == "transferencia_interna" ? "Interna" : "Externa"
        }}: #
        {{ dados.numero }}
      </p>
      <router-link
        v-if="tipoTransferencia.toLowerCase() === 'transferencia_interna'"
        :to="{ name: 'ferramentaria-transferencia-interna' }"
      >
        <div
          style="cursor: pointer"
          class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
        >
          <q-icon
            class="q-mr-sm icon-voltar"
            name="west"
            size="25px"
            color="brand-5"
          />
          <span class="texto-titulo">Voltar</span>
        </div>
      </router-link>
      <router-link v-else :to="{ name: 'ferramentaria-transferencia-externa' }">
        <div
          style="cursor: pointer"
          class="row items-center text-weight-bold text-brand-5 q-mr-md container-link-voltar"
        >
          <q-icon
            class="q-mr-sm icon-voltar"
            name="west"
            size="25px"
            color="brand-5"
          />
          <span class="texto-titulo">Voltar</span>
        </div>
      </router-link>
    </div>
    <div class="row col-12 q-mt-lg items-center text-brand-5 text-weight-bold">
      <div class="row col-md col-xs-12">
        <div class="col-md col-xs col-sm">
          <div class="texto-titulo-input">Nº Transferência</div>
          <q-tooltip>
            {{ dados.numero }}
          </q-tooltip>
          <q-input
            v-model="dados.numero"
            disable
            bg-color="brand-7"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md col-xs col-sm q-ml-xs">
          <div class="texto-titulo-input">Origem</div>
          <q-tooltip>
            {{ transferencia.origem.nome }}
          </q-tooltip>
          <q-input
            v-model="transferencia.origem.nome"
            disable
            bg-color="brand-7"
            class="input"
            dense
            outlined
          />
        </div>
      </div>
      <div class="row col-md col-xs-12 sem-margin q-ml-xs">
        <div class="col-md col-xs col-sm">
          <div class="texto-titulo-input">Destino</div>
          <q-tooltip>
            {{ transferencia.destino.nome }}
          </q-tooltip>
          <q-input
            v-model="transferencia.destino.nome"
            disable
            bg-color="brand-7"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md col-xs col-sm q-ml-xs">
          <div class="texto-titulo-input">Status</div>
          <q-tooltip>
            {{ dados.status }}
          </q-tooltip>
          <q-input
            v-model="dados.status"
            disable
            bg-color="brand-7"
            class="input"
            dense
            outlined
          />
        </div>
      </div>
      <div class="row col-md col-xs-12 sem-margin items-center q-ml-xs">
        <div class="col-md col-xs">
          <div class="texto-titulo-input">Data de Criação</div>
          <q-tooltip>
            {{ transferencia.criadoEm }}
          </q-tooltip>
          <q-input
            v-model="transferencia.criadoEm"
            disable
            bg-color="brand-7"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md col-xs q-ml-xs">
          <div class="texto-titulo-input">Data de Criação</div>
          <q-tooltip>
            {{ transferencia.criadoEm }}
          </q-tooltip>
          <q-input
            v-model="transferencia.criadoEm"
            disable
            bg-color="brand-7"
            class="input"
            dense
            outlined
          />
        </div>
      </div>
    </div>
    <div class="row col-12 q-mt-md items-center text-brand-5 text-weight-bold">
      <div class="row col-md col-xs-12">
        <div class="col-md col-xs col-sm" style="margin-top: -19px">
          <div class="texto-titulo-input">Pedido</div>
          <q-tooltip>
            {{ transferencia.pedido }}
          </q-tooltip>
          <q-input
            v-model="transferencia.pedido"
            class="input"
            dense
            outlined
            :bg-color="
              dados?.status == 'recebida' ||
              dados?.status == 'enviada' ||
              dados?.status == 'cancelada' ||
              dados?.status == 'rejeitada'
                ? 'brand-7'
                : ''
            "
            :disable="
              dados?.status == 'recebida' ||
              dados?.status == 'enviada' ||
              dados?.status == 'cancelada' ||
              dados?.status == 'rejeitada'
            "
          />
        </div>
        <div class="col-md col-xs col-sm q-ml-xs" style="margin-top: -19px">
          <div class="texto-titulo-input">Solicitação de Compra</div>
          <q-tooltip>
            {{ transferencia.solicitacaoCompra }}
          </q-tooltip>
          <q-input
            v-model="transferencia.solicitacaoCompra"
            class="input"
            dense
            outlined
            :disable="
              dados?.status == 'recebida' ||
              dados?.status == 'cancelada' ||
              dados?.status == 'enviada' ||
              dados?.status == 'rejeitada'
            "
            :bg-color="
              dados?.status == 'recebida' ||
              dados?.status == 'cancelada' ||
              dados?.status == 'enviada' ||
              dados?.status == 'rejeitada'
                ? 'brand-7'
                : ''
            "
          />
        </div>
      </div>
      <div class="row col-md col-xs-12 q-ml-xs sem-margin">
        <div class="col-md col-xs col-sm">
          <div class="texto-titulo-input">
            Documento Tipo
            <span
              v-if="isTransferenciaExterna && possuiAtivoLocado"
              class="text-red"
              style="margin-left: 3px"
              >*</span
            >
          </div>
          <q-tooltip>
            {{ dados.documentoTipo }}
          </q-tooltip>
          <q-select
            v-model="dados.documentoTipo"
            behavior="menu"
            class="input"
            :options="options.documentoTipo"
            dense
            map-options
            outlined
            :disable="dados?.status != 'criada'"
            :bg-color="dados?.status != 'criada' ? 'brand-7' : ''"
            :rules="[
              (val) =>
                !(isTransferenciaExterna && possuiAtivoLocado) ||
                (val && val.trim() !== '') ||
                'Documento Tipo é obrigatório para ativos locados',
            ]"
            :class="{ 'text-red': isTransferenciaExterna && possuiAtivoLocado }"
          />
        </div>

        <div class="col-md col-xs col-sm q-ml-xs">
          <div class="texto-titulo-input">
            Documento Número
            <span
              v-if="isTransferenciaExterna && possuiAtivoLocado"
              class="text-red"
              style="margin-left: 3px"
              >*</span
            >
          </div>
          <q-tooltip>
            {{ dados.documentoNumero }}
          </q-tooltip>
          <q-input
            v-model="dados.documentoNumero"
            class="input"
            dense
            outlined
            :disable="dados?.status != 'criada'"
            :bg-color="dados?.status != 'criada' ? 'brand-7' : ''"
            :rules="[
              (val) =>
                !(isTransferenciaExterna && possuiAtivoLocado) ||
                (val && val.trim() !== '' && val.length >= 5) ||
                'Documento Número é obrigatório para ativos locados',
            ]"
            :class="{ 'text-red': isTransferenciaExterna && possuiAtivoLocado }"
          />
        </div>
      </div>
      <div class="row col-md col-xs-12 q-ml-xs sem-margin">
        <div class="col-md col-xs col-sm">
          <div class="texto-titulo-input">Documento Série</div>
          <q-tooltip>
            {{ dados.documentoSerie }}
          </q-tooltip>
          <q-input
            v-model="dados.documentoSerie"
            class="input"
            dense
            outlined
            :disable="dados?.status != 'criada'"
            :bg-color="dados?.status != 'criada' ? 'brand-7' : ''"
          />
        </div>
        <div class="col-md col-xs col-sm q-ml-xs">
          <div class="texto-titulo-input">Data Emissão</div>
          <q-tooltip>
            {{ dataEmissao }}
          </q-tooltip>
          <q-input
            dense
            outlined
            class="input col-12"
            placeholder="DD/MM/AAAA"
            v-model="dataEmissao"
            mask="##/##/####"
            :bg-color="dados?.status != 'criada' ? 'brand-7' : ''"
            :disable="dados?.status != 'criada'"
            :rules="[
              (val) =>
                val == '' || val.length == 10 || 'Digite a Data Completa',
            ]"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    v-model="dataEmissao"
                    :options="validacaodata"
                    mask="DD/MM/YYYY"
                    :rules="[
                      (val) =>
                        val == '' ||
                        val.length == 10 ||
                        'Digite a Data Completa',
                    ]"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
      </div>
    </div>
    <div class="q-mt-xl">
      <div v-if="dados.status === 'criada'">
        <div class="row col-12 justify-between items-center q-mt-sm">
          <div
            class="row items-center text-brand-5 text-weight-bold items-center"
          >
            <div class="q-ml-md titulo-tabela">
              {{
                criarAtivoCatalogo ? "Itens de Catálogo" : "Ativos Disponíveis"
              }}
            </div>
          </div>

          <div
            v-if="dados.status == 'criada'"
            class="row items-center q-gutter-sm q-mb-sm"
          >
            <q-btn
              icon="group"
              outline
              color="black"
              label="Histórico de Status"
              class="btn"
              no-caps
              @click="rightDrawerPessoas = true"
            />
            <UploadDocumentos
              :tipoAnexo="'transferencia'"
              :transferenciaUuid="transferenciaId"
              :listaAnexo="listaAnexo"
              @atualizar="detalharTransferencia"
            />

            <div v-if="tipoTransferencia === 'transferencia_interna'">
              <router-link
                target="_blank"
                :to="{
                  name: 'ferramentaria-transferencia-impressao-romaneio-interna',
                  params: { transferenciaId: transferenciaId },
                }"
              >
                <q-btn
                  icon="print"
                  color="primary"
                  outline
                  class="btn-imprimir"
                />
              </router-link>
            </div>

            <div class="q-ml-xs" v-else>
              <router-link
                target="_blank"
                :to="{
                  name: 'ferramentaria-transferencia-impressao-romaneio-externa',
                  params: { transferenciaId: transferenciaId },
                }"
              >
                <q-btn
                  icon="print"
                  outline
                  color="primary"
                  class="btn-imprimir"
                />
              </router-link>
            </div>
          </div>
        </div>
        <div class="q-mb-sm">
          <ComponenteFiltros
            v-if="criarAtivoCatalogo"
            :codigo="true"
            :classCodigo="'col-md col-xs-6'"
            :descricao="true"
            :classDescricao="'col-md col-xs-5'"
            :patrimonio="true"
            :classPatrimonio="'col-md col-xs-6'"
            :subgrupo="true"
            :classGrupo="'col-md col-xs-5'"
            :classSubgrupo="'col-md col-xs-6'"
            @enviarFiltro="receberFiltro"
          />
          <ComponenteFiltros
            v-else
            :fornecedor="true"
            :classFornecedor="'col-md col-xs-5'"
            :codigo="true"
            :classCodigo="'col-md col-xs-6'"
            :descricao="true"
            :patrimonio="true"
            :classPatrimonio="'col-md col-xs-6'"
            :classDescricao="'col-md col-xs-5'"
            :subgrupo="true"
            :classGrupo="'col-md col-xs-5'"
            :classSubgrupo="'col-md col-xs-6'"
            @enviarFiltro="receberFiltro"
          />
        </div>
        <q-tabs
          v-if="tipoTransferencia === 'transferencia_externa'"
          dense
          class="text-grey bg-grey-3 q-mb-sm"
          active-color="black"
          indicator-color="primary"
          active-bg-color="brand-11"
          no-caps
          align="justify"
          narrow-indicator
          inline-label
          v-model="tab"
        >
          <q-tab
            style="background-color: #d9d9d9; border-radius: 4px"
            name="selecionarAtivo"
            label="Selecionar Ativo"
            no-caps
          />
          <q-tab
            class="q-ml-sm q-mr-sm"
            style="background-color: #d9d9d9; border-radius: 4px"
            name="criarAtivo"
            label="Criar Ativo"
            no-caps
          />
        </q-tabs>
        <q-linear-progress v-if="loading" indeterminate size="3px" />
        <q-table
          table-header-class="bg-accent text-weight-bold"
          :columns="criarAtivoCatalogo ? columnsItem : columns"
          :rows="criarAtivoCatalogo ? listaItensCatalogo : listaAtivos"
          :rows-per-page-options="[0]"
          dense
          flat
          :row-key="criarAtivoCatalogo ? 'uuid' : 'ativoUuid'"
          @request="handleRequest"
          binary-state-sort
          v-model:pagination="pagination"
          selection="multiple"
          v-model:selected="selected"
          :class="{ 'my-sticky-dynamic': !mobile }"
          :hide-bottom="
            !listaItensCatalogo.length == 0 || !listaAtivos.length == 0
          "
          no-data-label="Nenhum ativo escontrado."
          :grid="mobile"
        >
          <template v-slot:item="props">
            <q-card
              class="container-grid-table row col-12 q-mb-sm"
              :style="
                props.selected
                  ? 'transform: scale(0.98); background: #b7cdf6'
                  : ''
              "
              @click="props.selected = !props.selected"
            >
              <div class="row col-12 items-center q-pa-sm">
                <div class="col-10">
                  <div class="row col-12">
                    <span
                      ><strong>Código: </strong
                      >{{
                        props.row.catalogoItemCodigo ||
                        props.row?.catalogoItem?.codigo ||
                        props.row.codigo
                      }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Descrição: </strong
                      >{{
                        props.row.descricao || props.row?.catalogoItem?.nome
                      }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Grupo: </strong
                      >{{
                        props.row?.grupo?.nome ||
                        props.row?.catalogoItem?.catalogoGrupo?.nome
                      }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span
                      ><strong>Subgrupo: </strong
                      >{{
                        props.row?.subgrupo?.nome ||
                        props.row?.catalogoItem?.catalogoSubGrupo?.nome
                      }}</span
                    >
                  </div>
                  <div v-if="!criarAtivoCatalogo" class="row col-12">
                    <span
                      ><strong>Preço: </strong
                      >{{ props.row.preco || props.row.valor }}</span
                    >
                  </div>
                  <div v-if="!criarAtivoCatalogo" class="row col-12">
                    <span
                      ><strong>Status: </strong
                      >{{
                        `${props.row?.status?.charAt(
                          0
                        )}${props.row?.status?.substring(1)}`
                      }}</span
                    >
                  </div>
                  <div v-if="!criarAtivoCatalogo" class="row col-12">
                    <span
                      ><strong>Patrimônio: </strong
                      >{{ props.row.patrimonio }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <div
                      v-if="props.row?.atributos?.length > 0"
                      class="row col-12"
                    >
                      <span class="q-mr-sm"
                        ><strong>Chave: </strong
                        >{{ props.row?.atributos[0].chave }}</span
                      >
                      <span
                        ><strong>Valor: </strong
                        >{{ props.row?.atributos[0].valor
                        }}<span v-if="props.row?.atributos?.length > 1"
                          >....</span
                        ></span
                      >
                      <q-tooltip v-if="props.row?.atributos?.length > 1">
                        <div
                          v-for="(atributo, index) in props.row.atributos"
                          :key="index"
                        >
                          <div class="row col-12" v-if="atributo.valor">
                            <div class="row col-12 justify-between">
                              <span class="q-mr-sm"
                                >Chave: {{ atributo.chave }}
                              </span>
                              <span>Valor: {{ atributo.valor }}</span>
                            </div>
                          </div>
                        </div>
                      </q-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>
                <q-btn
                  round
                  size="10px"
                  :icon="props.selected ? 'close' : 'add'"
                  :color="props.selected ? 'red' : 'secondary'"
                  @click="
                    tab == 'criarAtivo'
                      ? adicicionarItem(props.row)
                      : (props.selected = !props.selected)
                  "
                  :disable="disable"
                />
              </q-td>
              <q-td>
                {{
                  props.row.catalogoItemCodigo ||
                  props.row?.catalogoItem?.codigo ||
                  props.row.codigo
                }}
              </q-td>
              <q-td>
                {{ props.row.descricao || props.row?.catalogoItem?.nome }}
              </q-td>
              <q-td>
                {{
                  props.row?.grupo?.nome ||
                  props.row?.catalogoItem?.catalogoGrupo?.nome
                }}
              </q-td>
              <q-td>
                {{
                  props.row?.subgrupo?.nome ||
                  props.row?.catalogoItem?.catalogoSubGrupo?.nome
                }}
              </q-td>
              <q-td v-if="!criarAtivoCatalogo">
                {{ props.row.preco || props.row.valor }}
              </q-td>
              <q-td v-if="!criarAtivoCatalogo">
                {{ props.row.origem }}
              </q-td>

              <q-td v-if="!criarAtivoCatalogo">
                {{
                  `${props.row?.status?.charAt(
                    0
                  )}${props.row?.status?.substring(1)}`
                }}
              </q-td>
              <q-td v-if="!criarAtivoCatalogo">
                {{ props.row.fornecedorNome }}
              </q-td>
              <q-td v-if="!criarAtivoCatalogo">
                {{ props.row.patrimonio }}
              </q-td>
              <q-td v-if="!criarAtivoCatalogo">
                <div v-if="props.row?.atributos?.length > 0">
                  <div>
                    <span class="q-mr-xs"
                      >Chave: {{ props.row?.atributos[0].chave }}
                    </span>
                    <span> Valor: {{ props.row?.atributos[0].valor }}</span>
                    <span v-if="props.row?.atributos?.length > 1">....</span>
                  </div>
                  <q-tooltip v-if="props.row?.atributos?.length > 1">
                    <div
                      v-for="(atributo, index) in props.row.atributos"
                      :key="index"
                    >
                      <div class="row col-12" v-if="atributo.valor">
                        <div class="row col-12 justify-between">
                          <span class="q-mr-sm"
                            >Chave: {{ atributo.chave }}
                          </span>
                          <span> Valor: {{ atributo.valor }}</span>
                        </div>
                      </div>
                    </div>
                  </q-tooltip>
                </div>
                <div v-else>Sem Atributos</div>
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <div class="row justify-center q-mt-md">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :max-pages="5"
            :boundary-numbers="false"
            :direction-links="true"
            :size="mobile ? 'md' : 'sm'"
          />
        </div>
      </div>
    </div>
    <div
      v-if="dados.status != 'rejeitada' && selected.length > 0"
      :class="{ 'q-mt-xl': dados.status === 'criada' }"
    >
      <div class="row col-12 justify-between items-center q-mt-sm">
        <div
          class="row items-center text-brand-5 text-weight-bold items-center"
        >
          <div class="q-ml-md titulo-tabela">
            {{
              dados.status == "criada"
                ? criarAtivoCatalogo
                  ? "Itens Selecionados"
                  : "Ativos Adicionados na Transferência"
                : dados.status == "enviada"
                ? "Ativos Selecionados"
                : dados.status == "recebida" ||
                  dados.status == "recebida_parcial"
                ? "Ativos Recebidos"
                : ""
            }}
          </div>
        </div>
        <div
          v-if="dados.status != 'criada'"
          class="row items-center q-gutter-sm q-mb-sm"
        >
          <div v-if="dados?.origemRejeicaoUuid != null">
            <router-link
              target="_blank"
              style="text-decoration: none"
              :to="{
                name: `ferramentaria-detalhe-${
                  tipoTransferencia == 'transferencia_interna'
                    ? 'transferencia-interna'
                    : 'transferencia-externa'
                }`,
                params: { transferenciaId: dados?.origemRejeicaoUuid },
              }"
            >
              <q-btn
                outline
                label="Origem da Rejeição"
                color="red"
                icon="info"
                no-caps
              />
            </router-link>
          </div>
          <q-btn
            icon="group"
            outline
            color="black"
            label="Histórico de Status"
            class="btn"
            no-caps
            @click="rightDrawerPessoas = true"
          />
          <UploadDocumentos
            :tipoAnexo="'transferencia'"
            :transferenciaUuid="transferenciaId"
            :listaAnexo="listaAnexo"
            @atualizar="detalharTransferencia"
          />
          <div v-show="tipoTransferencia === 'transferencia_interna'">
            <router-link
              target="_blank"
              :to="{
                name: 'ferramentaria-transferencia-impressao-romaneio-interna-simplificada',
                params: { transferenciaId: transferenciaId },
              }"
            >
              <q-btn
                icon="list"
                color="secondary"
                outline
                class="btn-imprimir"
              />
            </router-link>
          </div>
          <div v-if="tipoTransferencia === 'transferencia_interna'">
            <router-link
              target="_blank"
              :to="{
                name: 'ferramentaria-transferencia-impressao-romaneio-interna',
                params: { transferenciaId: transferenciaId },
              }"
            >
              <q-btn
                icon="print"
                outline
                color="primary"
                class="btn-imprimir"
              />
            </router-link>
          </div>
          <div class="q-ml-xs" v-else>
            <router-link
              target="_blank"
              :to="{
                name: 'ferramentaria-transferencia-impressao-romaneio-externa',
                params: { transferenciaId: transferenciaId },
              }"
            >
              <q-btn
                icon="print"
                outline
                color="primary"
                class="btn-imprimir"
              />
            </router-link>
          </div>
        </div>
      </div>
      <ComponenteChecklistAcessorio
        v-if="!criarAtivoCatalogo"
        :etapa="tipoTransferencia"
        :verificar="validarRespostas"
        :catalogoUuid="catalogoEspecificoUuid"
        :expandirCard="atualizarListaCards"
        :arrayRejeitados="ativosRejeitar"
        :atualizarRejeitados="atualizarRejeitados"
        :arrayRespostas="
          dados.status == 'criada' || dados.status == 'enviada'
            ? selected
            : selectedRecebidos
        "
        :respostas="respostas"
        :transferencia="dados.status == 'criada'"
        :historico="true"
        :verificarOperacao="true"
        :tipoTransferencia="tipoTransferencia"
        :botaoRemover="dados.status == 'criada'"
        :statusTransferencia="dados.status"
        :deposito="
          dados.status == 'enviada' &&
          transferencia?.destino?.destinoTipo == 'unidade'
        "
        :unidadeIdEspecifico="
          tipoTransferencia == 'transferencia_interna'
            ? transferencia?.destino?.id
            : transferencia?.origem?.origemTipo == 'unidade'
            ? transferencia.origem.id
            : transferencia.destino.id
        "
        :fornecedorId="
          transferencia?.origem?.origemTipo == 'fornecedor'
            ? transferencia?.origem?.id
            : undefined
        "
        :fornecedorAlocado="
          transferencia?.origem?.origemTipo == 'fornecedor' ? true : false
        "
        :perguntas="dados.status == 'criada' || dados.status == 'enviada'"
        :tela="'transferencia'"
        :transferenciaOrigemTipo="transferencia?.origem?.origemTipo"
        @salvarAlteracoes="salvarAlteracoesSelecionado"
        @removerAtivo="removerItem"
        @enviarValidacaoRespostas="verificarStatus()"
        @vincularAtivo="
          (envioTransferencia = true),
            (edicaoAtivo = true),
            vincularAtivoTransferencia()
        "
      />
      <ComponenteChecklistAcessorio
        v-else
        :etapa="tipoTransferencia"
        :verificar="verificarRepostaCriacaoAtivo"
        :arrayRespostas="selected"
        :catalogoUuid="catalogoEspecificoUuid"
        :ativosErrosIndicatorNew="ativosErrosIndicatorNew"
        :respostas="respostas"
        :tela="'transferencia'"
        :botaoInformacoes="true"
        :transferencia="true"
        :botaoRemover="true"
        :verificarOperacao="true"
        :verificarStatus="true"
        :tipoTransferencia="tipoTransferencia"
        :atualizar="atualizarSelecionado"
        :statusTransferencia="'criada'"
        :historico="false"
        :perguntas="false"
        :unidadeIdEspecifico="
          tipoTransferencia == 'transferencia_interna'
            ? transferencia?.destino?.id
            : transferencia?.origem?.origemTipo == 'unidade'
            ? transferencia.origem.id
            : transferencia.destino.id
        "
        @salvarAlteracoes="salvarAlteracoesSelecionado"
        @removerAtivo="removerItemCriacao"
        @enviarValidacaoRespostas="vincularAtivoTransferencia()"
      />
    </div>
    <div
      v-if="selectedRejeitados.length > 0"
      :class="{ 'q-mt-xl': dados.status === 'recebida_parcial' }"
    >
      <div class="row col-12 justify-between items-center q-mt-sm">
        <div
          class="row items-center text-brand-5 text-weight-bold items-center"
        >
          <div class="q-ml-md titulo-tabela">
            {{ "Ativos Rejeitados" }}
          </div>
        </div>
        <div
          v-if="dados.status === 'rejeitada'"
          class="row items-center q-gutter-sm q-mb-sm"
        >
          <div v-if="dados?.origemRejeicaoUuid != null">
            <router-link
              target="_blank"
              style="text-decoration: none"
              :to="{
                name: `ferramentaria-detalhe-${
                  tipoTransferencia == 'transferencia_interna'
                    ? 'transferencia-interna'
                    : 'transferencia-externa'
                }`,
                params: { transferenciaId: dados?.origemRejeicaoUuid },
              }"
            >
              <q-btn
                outline
                label="Origem da Rejeição"
                color="red"
                icon="info"
                no-caps
              />
            </router-link>
          </div>
          <q-btn
            icon="group"
            outline
            color="black"
            label="Histórico de Status"
            class="btn"
            no-caps
            @click="rightDrawerPessoas = true"
          />
          <UploadDocumentos
            :tipoAnexo="'transferencia'"
            :transferenciaUuid="transferenciaId"
            :listaAnexo="listaAnexo"
            @atualizar="detalharTransferencia"
          />
          <div v-if="tipoTransferencia === 'transferencia_interna'">
            <router-link
              target="_blank"
              :to="{
                name: 'ferramentaria-transferencia-impressao-romaneio-interna',
                params: { transferenciaId: transferenciaId },
              }"
            >
              <q-btn
                icon="print"
                outline
                color="primary"
                class="btn-imprimir"
              />
            </router-link>
          </div>
          <div class="q-ml-xs" v-else>
            <router-link
              target="_blank"
              :to="{
                name: 'ferramentaria-transferencia-impressao-romaneio-externa',
                params: { transferenciaId: transferenciaId },
              }"
            >
              <q-btn
                icon="print"
                outline
                color="primary"
                class="btn-imprimir"
              />
            </router-link>
          </div>
        </div>
      </div>

      <ComponenteChecklistAcessorio
        v-if="selectedRejeitados.length > 0"
        :etapa="tipoTransferencia"
        :verificar="validarRespostas"
        :catalogoUuid="catalogoEspecificoUuid"
        :arrayRespostas="selectedRejeitados"
        :respostas="respostas"
        :transferencia="dados.status == 'criada'"
        :statusTransferencia="dados.status"
        :historico="true"
        :tipoTransferencia="tipoTransferencia"
        :botaoRemover="dados.status == 'criada'"
        :deposito="
          dados.status == 'enviada' &&
          transferencia?.destino?.destinoTipo == 'unidade'
        "
        :unidadeIdEspecifico="
          tipoTransferencia == 'transferencia_interna'
            ? transferencia?.destino?.id
            : transferencia?.origem?.origemTipo == 'unidade'
            ? transferencia.origem.id
            : transferencia.destino.id
        "
        :perguntas="dados.status == 'criada' || dados.status == 'enviada'"
        :tela="'transferencia'"
      />
    </div>

    <div
      class="row col-12 text-brand-5 text-weight-bold container-selecao-autenticacao"
      v-if="dados.status == 'criada' || dados.status == 'enviada'"
    >
      <div
        class="q-my-lg q-ml-sm row col-12 text-brand-5 text-weight-bold items-center justify-between"
      >
        <div class="titulo-autenticacao">Método de Autenticação</div>
      </div>
      <div
        v-for="(metodo, index) in metodoAutenticacao[0]?.metodos"
        :key="index"
      >
        <q-radio
          v-if="metodo != 'token'"
          :val="metodo"
          :label="`${metodo?.charAt(0)?.toUpperCase()}${metodo?.substring(1)}`"
          v-model="metodoSelected"
        />
      </div>
      <div
        class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-pin"
        v-if="metodoSelected === 'pin'"
      >
        <q-icon class="q-mr-xs" name="lock" size="28px" />
        <div class="col-md-2 col-xs-6">
          <q-input v-model="pin" type="password" dense outlined />
        </div>
      </div>
      <div
        class="row col-12 q-mt-lg q-ml-md items-center container-autenticacao-assinatura"
        v-if="metodoSelected === 'assinatura'"
      >
        <Canvas @update="receberAssinatura" :go="salvarAssinatura" />
      </div>
      <div
        class="column col-12 q-mt-lg q-ml-md"
        v-if="!mobile && metodoSelected === 'biometria'"
      >
        <div>
          <q-img
            v-if="biometriaVerificacao"
            class="imagem-biometria"
            src="../../../assets/bioOK.png"
            @click="biometriaModal = !biometriaModal"
          />
          <q-img
            v-else
            class="imagem-biometria"
            src="../../../assets/bioRequest.png"
            dadosTransferencia.solicitanteAutenticar.id
            @click="
              dadosTransferencia.solicitanteAutenticar.id != ''
                ? (biometriaModal = !biometriaModal)
                : biometriaModal
            "
          >
            <q-tooltip
              v-if="dadosTransferencia.solicitanteAutenticar.id == ''"
              anchor="top middle"
              self="bottom middle"
              :offset="[10, 10]"
            >
              Selecione o Requisitante abaixo
            </q-tooltip>
          </q-img>
          <span class="q-ml-sm text-bold text-brand-5" style="font-size: 16px"
            >Clique no icone da digital para reconhecimento da biometria.</span
          >
          <BiometriaModal
            :modal="biometriaModal"
            :userId="dadosTransferencia.solicitanteAutenticar.id"
            :titulo="'Verificação de Biometria'"
            :tipoBiometria="'verificacao'"
            @negativePrint="recebeBiometria"
            @resultadoVerificacao="receberResultadoBiometria"
          />
        </div>
      </div>
    </div>

    <div>
      <div
        class="row col-12 q-mt-lg q-gutter-sm btn-container"
        v-if="dados.status === 'criada' && !criarAtivoCatalogo"
      >
        <SelecaoFuncionario
          v-if="
            metodoSelected === 'assinatura' || metodoSelected === 'biometria'
          "
          @emitirFuncionario="receberSolicitanteAutenticar"
          :model="dadosTransferencia.solicitanteAutenticar"
        />

        <div>
          <q-btn
            label="Enviar Transferência"
            color="positive"
            :disable="
              metodoAutenticacao[0]?.obrigatorio == 'sim' &&
              /* eslint-disable-next-line padded-blocks */
              metodoSelected == null &&
              !metodoAutenticacao[0]?.metodos.includes('token') &&
              metodoSelected != 'pin' &&
              dadosTransferencia.solicitanteAutenticar.matricula == ''
            "
            no-caps
            icon="done"
            class="btn"
            @click="
              metodoSelected == 'assinatura'
                ? salvarAssinatura++
                : verificarDadosAdicionados()
            "
          />
        </div>
        <div>
          <q-btn
            label="Salvar"
            color="primary"
            no-caps
            icon="save"
            class="btn"
            @click="(envioTransferencia = false), vincularAtivoTransferencia()"
          />
        </div>
        <div>
          <router-link :to="{ name: 'ferramentaria-transferencia-interna' }">
            <q-btn
              icon="cancel"
              class="btn"
              no-caps
              color="red"
              label="Cancelar"
            />
          </router-link>
        </div>
      </div>
      <div
        class="row col-12 q-mt-lg q-gutter-sm btn-container"
        v-if="dados.status === 'criada' && criarAtivoCatalogo"
      >
        <div>
          <q-btn
            label="Criar"
            color="positive"
            no-caps
            :disable="disableCriacaoAtivo"
            icon="done"
            class="btn"
            @click="(vincularNovoAtivo = true), verificarRepostaCriacaoAtivo++"
          />
        </div>
        <div>
          <q-btn
            icon="cancel"
            class="btn"
            no-caps
            color="red"
            :disable="disableCriacaoAtivo"
            label="Cancelar"
            @click="(criarAtivoCatalogo = false), (tab = 'selecionarAtivo')"
          />
        </div>
      </div>
      <!--eslint-disable-->
      <div
        class="row col-12 q-mt-lg q-gutter-sm btn-container"
        v-if="dados.status === 'enviada'"
      >
        <SelecaoFuncionario
          v-if="
            metodoSelected === 'assinatura' || metodoSelected === 'biometria'
          "
          @emitirFuncionario="receberSolicitanteAutenticar"
          :model="dadosTransferencia.solicitanteAutenticar"
        />

        <div>
          <q-btn
            label="Receber Transferência"
            color="positive"
            no-caps
            icon="done"
            :disable="
              metodoAutenticacao[0]?.obrigatorio == 'sim' &&
              /* eslint-disable-next-line padded-blocks */
              metodoSelected == null &&
              !metodoAutenticacao[0]?.metodos.includes('token') &&
              metodoSelected != 'pin' &&
              dadosTransferencia.solicitanteAutenticar.matricula == ''
            "
            class="btn-enviada"
            @click="(receberTodosAtivos = true), validarRespostas++"
          />
        </div>
        <div>
          <q-btn
            label="Rejeitar Transferência"
            color="negative"
            no-caps
            icon="cancel"
            class="btn-enviada"
            @click="
              (rightDrawerOpenRejeitar = true),
                (ativosLista = [...ativosAdicionadosTransferencia])
            "
          />
        </div>
      </div>
    </div>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="rightDrawerOpen = false"
            />
            <span class="texto-titulo-modal"> Enviar Transferência </span>
          </div>
        </div>
        <q-scroll-area style="width: 100%; height: 89%">
          <div
            class="column col-12 justify-between no-wrap"
            style="height: 90%"
          >
            <div>
              <div class="q-px-md text-weight-bold">
                <div class="q-mt-sm texto-titulo-input-modal">Solicitante</div>
                <div class="row col-md-12 q-mt-xs justify-between">
                  <q-radio
                    v-model="dadosTransferencia.solicitante.funcionario"
                    val="sim"
                    class="col input-radio"
                    label="Funcionário"
                  />
                  <q-radio
                    v-model="dadosTransferencia.solicitante.funcionario"
                    val="nao"
                    class="col input-radio"
                    label="Não Funcionário"
                  />
                </div>
                <div>
                  <div
                    class="row col-md-12 q-mt-xs justify-between"
                    v-if="dadosTransferencia.solicitante.funcionario == 'sim'"
                  >
                    <div class="col">
                      <div class="texto-titulo-input q-mb-xs">Funcionário</div>
                      <SelecaoFuncionario
                        @emitirFuncionario="receberFuncionarioSolicitante"
                        :model="dadosTransferencia.solicitante"
                        :resetar="resetFuncionarioSolicitante"
                      />
                    </div>
                  </div>
                  <div
                    class="row col-md-12 q-mt-xs justify-between"
                    v-if="dadosTransferencia.solicitante.funcionario == 'nao'"
                  >
                    <div class="col">
                      <div class="texto-titulo-input q-mb-xs">Nome</div>
                      <q-input
                        v-model="dadosTransferencia.solicitante.nome"
                        dense
                        outlined
                      />
                    </div>
                    <div class="col q-ml-sm">
                      <div class="texto-titulo-input q-mb-xs">Matricula</div>
                      <q-input
                        v-model="dadosTransferencia.solicitante.matricula"
                        dense
                        outlined
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="q-px-md text-weight-bold">
                <div class="q-mt-md texto-titulo-input-modal">Expedidor</div>
                <div class="row col-md-12 q-mt-xs justify-between">
                  <q-radio
                    v-model="dadosTransferencia.expedidor.funcionario"
                    val="sim"
                    class="col input-radio"
                    label="Funcionário"
                  />
                  <q-radio
                    v-model="dadosTransferencia.expedidor.funcionario"
                    val="nao"
                    class="col input-radio"
                    label="Não Funcionário"
                  />
                </div>
                <div>
                  <div
                    class="row col-md-12 q-mt-xs justify-between"
                    v-if="dadosTransferencia.expedidor.funcionario == 'sim'"
                  >
                    <div class="col">
                      <div class="texto-titulo-input q-mb-xs">Funcionário</div>
                      <SelecaoFuncionario
                        @emitirFuncionario="receberFuncionarioExpedidor"
                        :model="dadosTransferencia.expedidor"
                        :resetar="resetFuncionarioExpedidor"
                      />
                    </div>
                  </div>
                  <div
                    v-if="dadosTransferencia.expedidor.funcionario == 'nao'"
                    class="row col-md-12 q-mt-xs justify-between"
                  >
                    <div class="col">
                      <div class="texto-titulo-input q-mb-xs">Nome</div>
                      <q-input
                        v-model="dadosTransferencia.expedidor.nome"
                        dense
                        outlined
                      />
                    </div>
                    <div class="col q-ml-sm">
                      <div class="texto-titulo-input q-mb-xs">Matricula</div>
                      <q-input
                        v-model="dadosTransferencia.expedidor.matricula"
                        dense
                        outlined
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="q-px-md text-weight-bold">
                <div class="q-mt-md texto-titulo-input-modal">
                  Transportador
                </div>
                <div class="row col-md-12 q-mt-xs justify-between">
                  <q-radio
                    v-model="dadosTransferencia.transportador.funcionario"
                    val="sim"
                    class="col input-radio"
                    label="Funcionário"
                  />
                  <q-radio
                    v-model="dadosTransferencia.transportador.funcionario"
                    val="nao"
                    class="col input-radio"
                    label="Não Funcionário"
                  />
                </div>
                <div>
                  <div
                    class="row col-md-12 q-mt-xs justify-between"
                    v-if="dadosTransferencia.transportador.funcionario == 'sim'"
                  >
                    <div class="col">
                      <div class="texto-titulo-input q-mb-xs">Funcionário</div>
                      <SelecaoFuncionario
                        @emitirFuncionario="receberFuncionarioTransportador"
                        :resetar="resetFuncionarioTransportador"
                        :model="dadosTransferencia.transportador"
                      />
                    </div>
                  </div>
                  <div
                    v-if="dadosTransferencia.transportador.funcionario == 'nao'"
                    class="row col-md-12 q-mt-xs justify-between"
                  >
                    <div class="col">
                      <div class="texto-titulo-input q-mb-xs">Nome</div>
                      <q-input
                        v-model="dadosTransferencia.transportador.nome"
                        dense
                        outlined
                      />
                    </div>
                    <div class="col q-ml-sm">
                      <div class="texto-titulo-input q-mb-xs">Matricula</div>
                      <q-input
                        v-model="dadosTransferencia.transportador.documento"
                        dense
                        outlined
                      />
                    </div>
                  </div>
                </div>
                <div class="row col-md-12 q-mt-xs justify-between">
                  <div class="col">
                    <div class="texto-titulo-input q-mb-xs">Veiculo</div>
                    <q-input
                      v-model="dadosTransferencia.transportador.veiculo"
                      dense
                      outlined
                    />
                  </div>
                  <div class="col q-ml-sm">
                    <div class="texto-titulo-input q-mb-xs">Placa</div>
                    <q-input
                      v-model="dadosTransferencia.transportador.placa"
                      dense
                      outlined
                    />
                  </div>
                  <div class="col-12 q-mt-xs q-mb-lg">
                    <div class="texto-titulo-input q-mb-xs">Observação</div>
                    <q-input
                      :input-style="{ maxHeight: '150px' }"
                      outlined
                      type="textarea"
                      v-model="observacao"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="q-my-sm q-px-md">
              <q-btn
                label="Enviar"
                color="positive"
                no-caps
                :disable="enviandoTransfencia"
                class="btn-modal"
                icon="done"
                @click="enviarTransferencia()"
              />
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpenRejeitar" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="rightDrawerOpenRejeitar = false"
            />
            <span class="texto-titulo-modal"> Rejeitar Transferência </span>
          </div>
        </div>
        <q-scroll-area style="width: 100%; height: 89%">
          <div
            class="column col-12 justify-between no-wrap"
            style="width: 100%; height: 90%"
          >
            <div class="col-12 q-mt-md">
              <q-table
                grid
                dense
                flat
                :columns="columnsRejeitar"
                hide-bottom
                :rows="selected"
                :rows-per-page-options="[0]"
                row-key="id"
              >
                <template v-slot:item="props">
                  <div class="col-12 q-px-sm q-mt-sm">
                    <div class="row card text-grid-table text-brand-5 q-pa-sm">
                      <div class="row col-12 justify-between items-center">
                        <div class="col-4">
                          <div class="row">
                            <q-checkbox
                              v-model="ativosRejeitar"
                              :val="props.row.ativoUuid"
                            />
                          </div>
                        </div>
                        <div class="col">
                          <div class="row col-12 q-mt-sm">
                            <span class="row col-12 q-mr-sm"
                              ><strong class="q-mr-xs">Código: </strong>
                              {{ props.row.codigo }}</span
                            >
                            <span class="row col-12 q-mr-sm"
                              ><strong class="q-mr-xs">Nome: </strong>
                              {{ props.row.descricao }}</span
                            >
                            <span class="row col-12 q-mr-sm"
                              ><strong class="q-mr-xs">Preço: </strong>
                              {{ props.row.preco }}</span
                            >
                            <span class="row col-12 q-mr-sm"
                              ><strong class="q-mr-xs">Patrimônio: </strong>
                              {{ props.row.patrimonio }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </q-table>
            </div>
            <div class="q-mb-sm q-mt-md q-px-sm">
              <q-btn
                label="Salvar"
                color="primary"
                no-caps
                class="btn-modal"
                icon="save"
                @click="confirmRejeitar = true"
              />
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <Transition name="slide-fade">
      <q-card v-if="rightDrawerPessoas" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="rightDrawerPessoas = false"
            />
            <span class="texto-titulo-modal"> Pessoas </span>
          </div>
        </div>
        <q-scroll-area style="width: 100%; height: 89%">
          <div
            class="column col-12 justify-between no-wrap"
            style="width: 100%; height: 90%"
          >
            <div class="col-12 q-mt-md text-weight-bold">
              <q-separator
                v-if="dadosTransferencia.solicitante.nome != ''"
                color="brand-5"
              />
              <div
                v-if="dadosTransferencia.solicitante.nome != ''"
                class="col-12 q-ml-md q-mt-sm texto-modal-pessoa"
              >
                <div>Solicitante:</div>
                <div class="row q-mr-sm col-12 justify-between">
                  <span> Nome: {{ dadosTransferencia.solicitante.nome }} </span>
                  <span>
                    Matrícula: {{ dadosTransferencia.solicitante.matricula }}
                  </span>
                </div>
                <div class="row col-12">
                  <span>
                    Data: {{ dadosTransferencia.solicitante.criadoEm }}
                  </span>
                </div>
              </div>
              <q-separator
                v-if="dadosTransferencia.expedidor.nome != ''"
                color="brand-5"
              />
              <div
                v-if="dadosTransferencia.expedidor.nome != ''"
                class="col-12 q-ml-md q-mt-sm texto-modal-pessoa"
              >
                <div>Expedidor:</div>
                <div class="row q-mr-sm col-12 justify-between">
                  <span> Nome: {{ dadosTransferencia.expedidor.nome }} </span>
                  <span>
                    Matrícula: {{ dadosTransferencia.expedidor.matricula }}
                  </span>
                </div>
                <div class="row col-12">
                  <span>
                    Data: {{ dadosTransferencia.expedidor.criadoEm }}
                  </span>
                </div>
              </div>
              <q-separator
                v-if="dadosTransferencia.transportador.nome != ''"
                color="brand-5"
              />
              <div
                v-if="dadosTransferencia.transportador.nome != ''"
                class="col-12 q-ml-md q-mt-sm texto-modal-pessoa"
              >
                <div>Transportador:</div>
                <div class="row q-mr-sm col-12 justify-between">
                  <span>
                    Nome: {{ dadosTransferencia.transportador.nome }}
                  </span>
                  <span>
                    Matrícula:
                    {{ dadosTransferencia.transportador.documento }}
                  </span>
                </div>
                <div class="row col-12">
                  <span>
                    Data: {{ dadosTransferencia.transportador.criadoEm }}
                  </span>
                </div>
              </div>
              <q-separator
                v-if="dadosTransferencia.criador.nome != ''"
                color="brand-5"
              />
              <div
                v-if="dadosTransferencia.criador.nome != ''"
                class="col-12 q-ml-md q-mt-sm texto-modal-pessoa"
              >
                <div>Criado Por:</div>
                <div class="row q-mr-sm col-12 justify-between">
                  <span> Nome: {{ dadosTransferencia.criador.nome }} </span>
                  <span>
                    Matrícula: {{ dadosTransferencia.criador.matricula }}
                  </span>
                </div>
                <div class="row col-12">
                  <span> Data: {{ dadosTransferencia.criador.criadoEm }} </span>
                </div>
              </div>
              <q-separator
                v-if="dadosTransferencia.remetente.nome != ''"
                color="brand-5"
              />
              <div
                v-if="dadosTransferencia.remetente.nome != ''"
                class="col-12 q-ml-md q-mt-sm texto-modal-pessoa"
              >
                <div>Enviado Por:</div>
                <div class="row q-mr-sm col-12 justify-between">
                  <span> Nome: {{ dadosTransferencia.remetente.nome }} </span>
                  <span>
                    Matrícula: {{ dadosTransferencia.remetente.matricula }}
                  </span>
                </div>
                <div class="row col-12">
                  <span>
                    Data: {{ dadosTransferencia.remetente.criadoEm }}
                  </span>
                </div>
              </div>
              <q-separator
                v-if="dadosTransferencia.recebedor.nome != ''"
                color="brand-5"
              />
              <div
                v-if="dadosTransferencia.recebedor.nome != ''"
                class="col-12 q-ml-md q-mt-sm texto-modal-pessoa"
              >
                <div>
                  {{
                    dados.status == "rejeitada"
                      ? "Rejeitado Por"
                      : "Recebido Por"
                  }}:
                </div>
                <div class="row q-mr-sm col-12 justify-between">
                  <span> Nome: {{ dadosTransferencia.recebedor.nome }} </span>
                  <span>
                    Matrícula: {{ dadosTransferencia.recebedor.matricula }}
                  </span>
                </div>
                <div class="row col-12">
                  <span>
                    Data: {{ dadosTransferencia.recebedor.criadoEm }}
                  </span>
                </div>
              </div>
              <q-separator
                v-if="dadosTransferencia.cancelador.nome != ''"
                color="brand-5"
              />
              <div
                v-if="dadosTransferencia.cancelador.nome != ''"
                class="col-12 q-ml-md q-mt-sm texto-modal-pessoa"
              >
                <div>Cancelado Por:</div>
                <div class="row q-mr-sm col-12 justify-between">
                  <span> Nome: {{ dadosTransferencia.cancelador.nome }} </span>
                  <span>
                    Matrícula: {{ dadosTransferencia.cancelador.matricula }}
                  </span>
                </div>
                <div class="row col-12">
                  <span>
                    Data: {{ dadosTransferencia.cancelador.criadoEm }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </q-scroll-area>
      </q-card>
    </Transition>
    <q-dialog v-model="confirmRejeitar" persistent>
      <q-card
        class="q-pa-sm container-modal-excluir text-brand-5 text-weight-bolder q-pa-xl"
      >
        <q-card-section class="row col-12 justify-center">
          <span class="texto-excluir-pai"
            >DESEJA SELECIONAR OS ATIVOS PARA REJEITAR?</span
          >
        </q-card-section>

        <div class="row col-12 justify-center">
          <q-btn
            no-caps
            label="Sim"
            color="positive"
            v-close-popup
            class="btn-excluir"
            icon="check_circle_outline"
            @click="
              (rightDrawerOpenRejeitar = false),
                (ativosSelecionadosRejeitar = [...ativosRejeitar]),
                atualizarRejeitados++,
                quasar.notify({
                  message:
                    'alteração feita. Os ativos selecionados ficarão com a borda na cor laranja.',
                  color: 'positive',
                  actions: [
                    {
                      label: 'Fechar',
                      color: 'white',
                      handler: () => {
                        /* ... */
                      },
                    },
                  ],
                })
            "
          />
          <q-btn
            icon="cancel"
            no-caps
            label="Não"
            color="negative"
            class="btn-excluir q-ml-md"
            @click="resetarRejeitados()"
            v-close-popup
          />
        </div>
      </q-card>
    </q-dialog>
    
    <ComponenteSelecionarCatalogoEspecifico
      :unidadeId="
        tipoTransferencia == 'transferencia_interna'
          ? dados.unidadeIdOrigem
          : transferencia?.origem?.origemTipo == 'unidade'
          ?  dados.unidadeIdOrigem
          :  dados.unidadeIdDestino
      "
      @enviarCatalogoEspecifico="receberCatalogoEspecifico"
    />
    <div
      v-if="
        rightDrawerOpen ||
        rightDrawerOpenRejeitar ||
        rightDrawerOpenDetalheItem ||
        rightDrawerOpenDetalheAtivo ||
        rightDrawerPessoas
      "
      @click="
        (rightDrawerOpen = false),
          (rightDrawerOpenRejeitar = false),
          (rightDrawerOpenDetalheItem = false),
          (rightDrawerOpenDetalheAtivo = false),
          (rightDrawerPessoas = false)
      "
      class="mascara"
    ></div>
  </q-page>
</template>

<script>
/* eslint-disable */
import { onMounted, ref, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { setupConfiguracao } from "../composables/setupConfiguracao";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";
import BiometriaModal from "../../biometria/views/Biometria.vue";
import Canvas from "../components/Canvas.vue";

import SelecaoFuncionario from "./SelecaoFuncionario.vue";
import UploadDocumentos from "./UploadDocumentos.vue";
import ComponenteChecklistAcessorio from "./ComponenteChecklistAcessorio.vue";
import ComponenteFiltros from "./ComponenteFiltros.vue";
import ComponenteSelecionarCatalogoEspecifico from "./ComponenteSelecionarCatalogoEspecifico.vue";

const columns = [
  {
    name: "selecionar",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    sortable: true,
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    sortable: true,
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
    sortable: true,
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
    sortable: true,
  },
  {
    name: "valor",
    label: "Preço",
    align: "left",
  },
  {
    name: "origem",
    label: "Origem",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
    sortable: true,
  },
  {
    name: "fornecedorCompra",
    label: "Fornecedor Compra",
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
    sortable: true,
  },
  {
    name: "atributo",
    label: "Atributo",
    align: "left",
  },
];

const columnsItem = [
  {
    name: "selecionar",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    sortable: true,
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
    sortable: true,
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
    sortable: true,
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
    sortable: true,
  },
];

const columnsItemSelecionado = [
  {
    name: "selecionar",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
  },
  {
    name: "operacao",
    label: "Operação",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
  {
    name: "detalhe",
    label: "Detalhe",
    align: "left",
  },
];

const columnsRejeitar = [
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "valor",
    label: "Preço",
    align: "left",
  },
];
export default {
  props: ["tipoTransferencia"],
  components: {
    SelecaoFuncionario,
    UploadDocumentos,
    ComponenteChecklistAcessorio,
    ComponenteFiltros,
    ComponenteSelecionarCatalogoEspecifico,
    BiometriaModal,
    Canvas,
  },
  setup(props) {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const quasar = useQuasar();
    const file = ref(null);
    const base64 = ref(null);
    const transferenciaId = route.params.transferenciaId;
    const tab = ref("selecionarAtivo");
    const configuracoesSetup = setupConfiguracao();
    const catalogoUuid = salvarCatalogoUuid();
    const dados = ref({
      numeroTransferencia: "",
      origem: "",
      destino: "",
      status: "",
      dataCriacao: "",
      pedido: "",
      solicitacaoCompra: "",
    });
    const ativosAdicionadosTransferencia = ref([]);
    const enviandoTransfencia = ref(false);
    const alterarRejeitados = ref(false);
    const listaAtivos = ref([]);
    const selected = ref([]);
    const selectStatus = ref(false);
    const metodoAutenticacao = ref([]);
    const salvarAssinatura = ref(0);
    const assinaturaBase64 = ref(null);
    let biometriaModal = ref(false);
    const base64Biometria = ref("teste");
    const pin = ref("");
    const selectOperacao = ref(false);
    const modalHistorico = ref(false);
    const confirmRejeitar = ref(false);
    let dataValida = new Date();
    const documentoTipo = ref("");
    const catalogoEspecificoUuid = ref("");
    const options = ref({
      statusOptions: [],
      operacaoOptions: [],
      depositoLocal: [],
      documentoTipo: [
        { label: "Nota Fiscal", value: "nf" },
        { label: "Romaneio", value: "romaneio" },
      ],
    });
    const verificarAtivosLocados = () => {
      return selected.value.some(ativo => {
        const origem = ativo.origem;
        const origemValue = origem?.value || origem;
        return origemValue?.toLowerCase() === 'locada';
      });
    };
    const filtros = ref({});
    const dadoAtributo = ref({ chave: "", valor: "" });
    const respostas = ref({});
    const validarRespostas = ref(0);
    const disable = ref(false);
    const loading = ref(false);
    const rightDrawerOpen = ref(false);
    const rightDrawerOpenRejeitar = ref(false);
    const rightDrawerOpenDetalheItem = ref(false);
    const rightDrawerOpenDetalheAtivo = ref(false);
    const rightDrawerPessoas = ref(false);
    let vincularNovoAtivo = ref(false);
    let disableCriacaoAtivo = ref(false);
    const recebendoTransferencia = ref(false);
    const dadosTransferencia = ref({
      solicitante: {
        nome: "",
        matricula: "",
        funcionario: "sim",
        criadoEm: "",
      },
      expedidor: {
        nome: "",
        matricula: "",
        funcionario: "sim",
        criadoEm: "",
      },
      transportador: {
        nome: "",
        documento: "",
        veiculo: "",
        placa: "",
        funcionario: "sim",
        criadoEm: "",
      },
      criador: {
        nome: "",
        matricula: "",
        criadoEm: "",
      },
      remetente: {
        nome: "",
        matricula: "",
        criadoEm: "",
      },
      recebedor: {
        nome: "",
        matricula: "",
        criadoEm: "",
      },
      cancelador: {
        nome: "",
        matricula: "",
        criadoEm: "",
      },
      solicitanteAutenticar: {
        nome: "",
        matricula: "",
        criadoEm: "",
        id: "",
      },
    });
    const dadosTransferenciaPreenchidos = ref(false);
    const ativosLista = ref([]);
    const ativosRejeitar = ref([]);
    const resetFuncionarioSolicitante = ref(0);
    const resetFuncionarioExpedidor = ref(0);
    const ativosSelecionadosRejeitar = ref([]);
    const resetFuncionarioTransportador = ref(0);
    const atualizarRejeitados = ref(0);
    const atualizarSelecionado = ref(0);
    const formAttributes = ref(null);
    const formInputs = ref(null);
    const resetarChecklist = ref(0);
    const observacao = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const listaItensCatalogo = ref([]);
    const selectedRejeitados = ref([]);
    const valorOrdenacao = ref("");
    const igual = ref(false);
    const selectedRecebidos = ref([]);
    const editarItemCatalogo = ref({});
    const metodoSelected = ref(null);
    const biometriaVerificacao = ref(false);
    const usuarioBiometria = ref(null);
    const selectedAtivos = ref([]);
    const ativosErrosIndicatorNew = ref([]);
    const selectedItens = ref([]);
    let criarAtivoCatalogo = ref(false);
    let envioTransferencia = ref(false);
    const verificarRepostaCriacaoAtivo = ref(0);
    const transferencia = ref({
      origem: { nome: "", id: "" },
      destino: { nome: "", id: "" },
      criadoEm: "",
      pedido: "",
      solicitacaoCompra: "",
    });
    const receberTodosAtivos = ref(false);
    const dataEmissao = ref("");
    const listaAnexo = ref([]);
    let mobile = ref(false);
    const salvarAtivoCriado = ref(false);
    const edicaoAtivo = ref(false);
    const atualizarListaCards = ref(0);
    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const detalharTransferencia = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      try {
        const response = await store.dispatch(
          "ferramentaria/detalharTransferencia",
          {
            transferenciaUuid: transferenciaId,
          }
        );
        let detalheTransferencia = response.data.resultado.dados;
        listaAnexo.value = detalheTransferencia.anexos;
        dados.value = { ...detalheTransferencia.dadosBasicos };
        dataEmissao.value = dados.value?.documentoEmissao
          ?.split(" ")[0]
          ?.split("-")
          .reverse()
          .join("/");
        transferencia.value = {
          origem: {
            nome:
              dados.value?.unidadeNomeOrigem ||
              dados.value?.fornecedorNomeOrigem,
            id: dados.value?.unidadeIdOrigem || dados.value?.fornecedorIdOrigem,
            origemTipo:
              dados.value?.unidadeNomeOrigem != "" &&
              dados.value?.unidadeNomeOrigem != null
                ? "unidade"
                : "fornecedor",
          },
          pedido: dados.value?.pedido,
          solicitacaoCompra: dados.value?.solicitacaoCompra,
          destino: {
            nome:
              dados.value?.unidadeNomeDestino ||
              dados.value?.fornecedorNomeDestino,
            id:
              dados.value?.unidadeIdDestino || dados.value?.fornecedorIdDestino,
            destinoTipo:
              dados.value?.unidadeNomeDestino != "" &&
              dados.value?.unidadeNomeDestino != null
                ? "unidade"
                : "fornecedor",
          },
          criadoEm: dados.value?.criadoEm
            .split(" ")[0]
            .split("-")
            .reverse()
            .join("/"),
        };
        if (detalheTransferencia.pessoas) {
          for (const key in detalheTransferencia.pessoas) {
            if (Object.hasOwnProperty.call(detalheTransferencia.pessoas, key)) {
              const element = detalheTransferencia.pessoas[key];
              switch (element.tipo) {
                case "solicitante":
                  dadosTransferencia.value.solicitante = {
                    nome: element.nome,
                    matricula: element.matricula,
                    funcionario: element?.funcionario,
                    criadoEm: `${element?.criadoEm
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")} ${element?.criadoEm.split(" ")[1]}`,
                  };
                  break;
                case "expedidor":
                  dadosTransferencia.value.expedidor = {
                    nome: element.nome,
                    matricula: element.matricula,
                    funcionario: element?.funcionario,
                    criadoEm: `${element?.criadoEm
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")} ${element?.criadoEm.split(" ")[1]}`,
                  };
                  break;
                case "criador":
                  dadosTransferencia.value.criador = {
                    nome: element.nome,
                    matricula: element.matricula,
                    criadoEm: `${element?.criadoEm
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")} ${element?.criadoEm.split(" ")[1]}`,
                  };
                  break;
                case "cancelador":
                  dadosTransferencia.value.cancelador = {
                    nome: element.nome,
                    matricula: element.matricula,
                    criadoEm: `${element?.criadoEm
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")} ${element?.criadoEm.split(" ")[1]}`,
                  };
                  break;
                case "recebedor":
                  dadosTransferencia.value.recebedor = {
                    nome: element.nome,
                    matricula: element.matricula,
                    criadoEm: `${element?.criadoEm
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")} ${element?.criadoEm.split(" ")[1]}`,
                  };
                  break;
                case "enviador":
                  dadosTransferencia.value.remetente = {
                    nome: element.nome,
                    matricula: element.matricula,
                    criadoEm: `${element?.criadoEm
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")} ${element?.criadoEm.split(" ")[1]}`,
                  };
                  break;
              }
            }
          }
        }
        if (detalheTransferencia?.transportador?.usuarioIdCriacao) {
          dadosTransferencia.value.transportador = {
            nome: detalheTransferencia?.transportador?.nome,
            documento: detalheTransferencia?.transportador?.documento,
            placa: detalheTransferencia?.transportador?.placaVeiculo,
            veiculo: detalheTransferencia?.transportador?.modeloVeiculo,
            funcionario: detalheTransferencia?.transportador?.funcionario,
            criadoEm: `${detalheTransferencia?.transportador.criadoEm
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("/")} ${
              detalheTransferencia?.transportador.criadoEm.split(" ")[1]
            }`,
          };
          observacao.value = detalheTransferencia?.transportador?.observacao;
        }
        if (detalheTransferencia?.ativos.length > 0) {
          criarListaAtivoSelecionado(detalheTransferencia?.ativos);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const listarAtivos = async (page = 1, perPage = 10, ordenacao = { nome: "desc" }) => {
      if (dados.value.status != "criada") {
        return;
      }
      loading.value = true;
      disable.value = true;
      try {
        const response = await store.dispatch("ferramentaria/listarAtivo", {
          ordenacao: ordenacao,
          unidadeId:
            transferencia.value.origem.origemTipo == "fornecedor"
              ? transferencia.value?.destino?.id
              : transferencia.value?.origem?.id,
          perPage: perPage,
          page: page,
          comCheckLists: "sim",
          comAtributos: "sim",
          comAcessorios: "sim",
          codigo: filtros.value?.codigo,
          nome: filtros.value?.descricao,
          nomeGrupo: filtros.value?.grupo?.nome,
          comMovimentacaoPermitida: "sim",
          nomeSubgrupo: filtros.value?.subgrupo?.nome,
          patrimonio: filtros.value.patrimonio,
          comFornecedorAlocado:
            transferencia.value.origem.origemTipo == "fornecedor"
              ? "sim"
              : undefined,
          fornecedorId: filtros.value?.fornecedor?.parceiroId,
        });
        listaAtivos.value = response.listaAtivo;
        pagination.value.page = response.response.data.resultado.currentPage;
        pagination.value.rowsPerPage = response.response.data.resultado.perPage;
        pagination.value.rowsNumber = response.response.data.resultado.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const removerItem = async (uuid) => {
      if (dados.value.status == "criada") {
        try {
          await store.dispatch("ferramentaria/desvincularAtivos", {
            transferenciaUuid: transferenciaId,
            ativos: [{ ativoUuid: uuid }],
          });
          detalharTransferencia();
          listarAtivos();
        } catch (error) {
          console.log(error);
          quasar.notify({
            message: "Erro a o desvincular ativo",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
      selected.value = selected.value.filter((item) => item.ativoUuid != uuid);
    };

    const receberCatalogoEspecifico = (value) => {

      catalogoEspecificoUuid.value = value;
    };

    const verificarDadosAdicionados = async () => {
  enviandoTransfencia.value = false;

  if (selected.value.length == 0) {
    quasar.notify({
      message: "Selecione ao menos um ativo.",
      color: "negative",
      actions: [{ label: "Fechar", color: "white" }]
    });
    return;
  }

  if (isTransferenciaExterna.value && possuiAtivoLocado.value) {
    if (!dados.value.documentoTipo || !dados.value.documentoNumero) {
      quasar.notify({
        message: "Documento Tipo e Documento Número são obrigatórios para ativos com origem 'locada'.",
        color: "negative",
        actions: [{ label: "Fechar", color: "white" }]
      });
      return;
    }

    if (dados.value.documentoNumero.length < 5) {
      quasar.notify({
        message: "O Documento Número deve ter pelo menos 5 caracteres para ativos locados.",
        color: "negative",
        actions: [{ label: "Fechar", color: "white" }]
      });
      return;
    }
  }

  validarRespostas.value++;
  envioTransferencia.value = true;
};

    const enviarTransferencia = async () => {
      salvarAssinatura.value++;
      enviandoTransfencia.value = true;
      let ativos = [];
      selected.value.forEach((ativo) => {
        ativos.push({
          ativoUuid: ativo.ativoUuid,
          checkLists:
            ativo?.checkLists?.length > 0
              ? verificarChecklist(ativo?.checkLists)
              : undefined,
          acessorios:
            ativo?.acessorios?.length > 0
              ? verificarAcessorio(ativo?.acessorios)
              : undefined,
        });
      });
      await vincularAtivoTransferencia();
      await editarTransferencia();
      try {
        if (metodoSelected.value == "assinatura") {
          if (
            assinaturaBase64.value == undefined ||
            assinaturaBase64.value == null
          ) {
            quasar.notify({
              message: "Faça a assinatura.",
              color: "negative",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });

            return;
          }
        } else if (metodoSelected.value == "pin") {
          const resposta = await verificarPinSolicitante();
          if (resposta) {
            quasar.notify({
              message: "PIN validado com Sucesso.",
              color: "positive",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          } else {
            return;
          }
        }

        if (metodoSelected.value == "biometria") {
          if (
            base64Biometria.value == undefined ||
            base64Biometria.value == null
          ) {
            quasar.notify({
              message: "Faça a verificação de biometria.",
              color: "negative",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            recebendoTransferencia.value = false;
            return;
          }
        }

        metodoSelected.value == "assinatura"
          ? await enviarBase64S3("assinatura")
          : metodoSelected.value == "biometria"
          ? await enviarBase64S3("biometria")
          : "";

        await store.dispatch("ferramentaria/enviarTransferencia", {
          transferenciaUuid: transferenciaId,
          enviador: {
            matricula: store.state.autenticacao.usuarioLogado.id,
            nome: store.state.autenticacao.usuarioLogado.nome,
            funcionario: "sim",
          },
          ativosRespostas: ativos,
          autorizadorId:
            metodoSelected.value == "pin" || metodoSelected.value == null
              ? store.state.autenticacao.usuarioLogado.id
              : dadosTransferencia.value.solicitanteAutenticar.matricula,
          autorizadorNome:
            metodoSelected.value == "pin" || metodoSelected.value == null
              ? store.state.autenticacao.usuarioLogado.nome
              : dadosTransferencia.value.solicitanteAutenticar.nome,
          autorizadorAuthType:
            metodoSelected.value == null ? "token" : metodoSelected.value,
          autorizadorAuthContent: await checkMetodoType(metodoSelected.value),
        });

        quasar.notify({
          message: "Transferência enviada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        if (props.tipoTransferencia == "transferencia_interna") {
          router.push({ name: "ferramentaria-transferencia-interna" });
          return;
        }
        router.push({ name: "ferramentaria-transferencia-externa" });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao enviar transferência.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        enviandoTransfencia.value = false;
      }
    };

    const isTransferenciaExterna = computed(() => {
      return route.path.includes('detalhe-transferencia-externa');
    });

    const possuiAtivoLocado = computed(() => {
      return selected.value.some(ativo => {
        const origem = ativo.origem;
        const origemValue = origem?.value || origem;
        return origemValue?.toLowerCase() === 'locada';
      });
    });

    const receberTransferencia = async () => {
      salvarAssinatura.value++;
      recebendoTransferencia.value = true;
      let ativos = [];
      selected.value.forEach((ativo) => {
        ativos.push({
          ativoUuid: ativo.ativoUuid,
          depositoLocalUuid: ativo?.deposito?.depositoLocalUuid,
          rejeitado: ativosRejeitar.value.some((v) => v === ativo?.ativoUuid)
            ? "sim"
            : "nao",
          patrimonio: ativo?.patrimonio,
          preco: parseFloat(ativo?.valor),
          valorLocacao: parseFloat(
            ativo?.valorLocacao == null ? 0 : ativo?.valorLocacao
          ),
          tempoPermanencia: parseFloat(ativo?.tempoPermanencia),
          motivoRejeicao: "",
          checkLists:
            ativo?.checkLists.length > 0
              ? verificarChecklist(ativo?.checkLists)
              : undefined,
          acessorios:
            ativo?.acessorios.length > 0
              ? verificarAcessorio(ativo?.acessorios)
              : undefined,
        });
      });

      try {
        if (metodoSelected.value == "assinatura") {
          if (
            assinaturaBase64.value == undefined ||
            assinaturaBase64.value == null
          ) {
            quasar.notify({
              message: "Faça a assinatura.",
              color: "negative",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            recebendoTransferencia.value = false;
            return;
          }
        } else if (metodoSelected.value == "pin") {
          const resposta = await verificarPinSolicitante();
          if (resposta) {
            quasar.notify({
              message: "PIN validado com Sucesso.",
              color: "positive",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
          } else {
            recebendoTransferencia.value = false;
            return;
          }
        }

        if (metodoSelected.value == "biometria") {
          if (
            base64Biometria.value == undefined ||
            base64Biometria.value == null
          ) {
            quasar.notify({
              message: "Faça a verificação de biometria.",
              color: "negative",
              actions: [
                {
                  label: "fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            recebendoTransferencia.value = false;
            return;
          }
        }
        metodoSelected.value == "assinatura"
          ? await enviarBase64S3("assinatura")
          : metodoSelected.value == "biometria"
          ? await enviarBase64S3("biometria")
          : "";
        await store.dispatch("ferramentaria/receberTransferencia", {
          transferenciaUuid: transferenciaId,
          recebedor: {
            matricula: store.state.autenticacao.usuarioLogado.id,
            nome: store.state.autenticacao.usuarioLogado.nome,
            funcionario: "sim",
          },
          ativos: ativos,
          autorizadorId:
            metodoSelected.value == "pin" || metodoSelected.value == null
              ? store.state.autenticacao.usuarioLogado.id
              : dadosTransferencia.value.solicitanteAutenticar.matricula,
          autorizadorNome:
            metodoSelected.value == "pin" || metodoSelected.value == null
              ? store.state.autenticacao.usuarioLogado.nome
              : dadosTransferencia.value.solicitanteAutenticar.nome,
          autorizadorAuthType:
            metodoSelected.value == null ? "token" : metodoSelected.value,
          autorizadorAuthContent: await checkMetodoType(metodoSelected.value),
        });

        quasar.notify({
          message: "Transferência recebida com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        if (props.tipoTransferencia == "transferencia_interna") {
          router.push({ name: "ferramentaria-transferencia-interna" });
          return;
        }
        router.push({ name: "ferramentaria-transferencia-externa" });
      } catch (error) {
        console.log(error);
        recebendoTransferencia.value = false;
        if (error?.response?.data?.erros?.mensagem) {
          quasar.notify({
            message: error?.response?.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const checkMetodoType = async (type) => {
      switch (type) {
        case "assinatura":
          return `${formAttributes.value.action}/${formInputs.value.key}`;

        case "pin":
          return undefined;

        case "biometria":
          return `${formAttributes.value.action}/${formInputs.value.key}`;
        case null:
          return store.state.autenticacao.token;

        default:
      }
    };

    const receberFiltro = (value) => {
      filtros.value = value;
      if (criarAtivoCatalogo.value) {
        listarItensCatalogo();
        return;
      }
      listarAtivos();
    };

    const vincularAtivoTransferencia = async () => {
      if (selected.value.length === 0) {
        quasar.notify({
          message: `Selecione ao menos um ${
            criarAtivoCatalogo.value ? "item" : "ativo"
          }.`,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (criarAtivoCatalogo.value) {
        let campoValido = verificarCampoPreenchido();
        if (!campoValido) {
          return;
        }
      }
      disableCriacaoAtivo.value = true;
      let ativos = [];
      selected.value.forEach(async (ativo) => {
        let quantidadeAtivos = verificarQuantidadeAtivoMultiplicado(ativo.uuid);
        if (ativo.multiplo > 1) {
          for (
            let i = 1;
            i < ativo.multiplo - (quantidadeAtivos.length - 1);
            i++
          ) {
            ativos.push({
              operacaoUuid: ativo?.operacao?.transferenciaOperacaoUuid,
              statusFinal: ativo?.status || ativo?.statusFinal,
              ativoUuid: ativo?.ativoUuid,
              patrimonio: ativo?.uuid ? undefined : ativo?.patrimonio,
              preco: ativo?.uuid ? undefined : parseFloat(ativo?.valor),
              valorLocacao: ativo?.uuid
                ? undefined
                : parseFloat(ativo?.valorLocacao),
              documentoTipo: ativo?.uuid
                ? undefined
                : documentoTipo?.value?.value,
              documentoSerie: ativo?.uuid
                ? undefined
                : dados.value.documentoSerie,
              documentoNumero: ativo?.uuid
                ? undefined
                : dados.value.numero.toString(),
              documentoEmissao: ativo?.uuid
                ? undefined
                : dataEmissao.value.split("/").reverse().join("-"),
              tempoPermanencia: ativo?.uuid
                ? undefined
                : parseFloat(ativo?.tempoPermanencia),
              novoAtivo: ativo?.uuid
                ? {
                    catalogoItemUuid: ativo?.uuid,
                    patrimonio: ativo?.patrimonio || "",
                    tempoPermanencia: parseFloat(ativo?.tempoPermanencia),
                    urlImagem: ativo?.url,
                    preco: parseFloat(ativo?.valor),
                    valorLocacao: parseFloat(ativo?.valorLocacao),
                    origem: ativo?.origem?.value,
                    documentoTipo: documentoTipo?.value?.value || "",
                    documentoSerie: dados.value.documentoSerie,
                    documentoNumero: dados.value.numero.toString(),
                    documentoEmissao: dataEmissao.value
                      .split("/")
                      .reverse()
                      .join("-"),
                    depositoLocalUuid: ativo?.deposito?.depositoLocalUuid,
                    responsavelId: ativo?.responsavel?.id || "",
                    atributos:
                      ativo?.atributos.length > 0
                        ? montarAtributoArray(ativo.atributos)
                        : undefined,
                    acessorios:
                      ativo?.acessorios.length > 0
                        ? montarAcessorioArray(ativo?.acessorios)
                        : undefined,
                    checkLists:
                      ativo?.checkLists.length > 0
                        ? montarChecklistArray(ativo?.checkLists)
                        : undefined,
                  }
                : undefined,
            });
          }
        } else {
          ativos.push({
            operacaoUuid: ativo?.operacao?.transferenciaOperacaoUuid,
            statusFinal: ativo?.status || ativo?.statusFinal,
            ativoUuid: ativo?.ativoUuid,
            editar:
              vincularNovoAtivo.value || !envioTransferencia.value
                ? undefined
                : ativo?.ativoFinal != undefined
                ? {
                    patrimonio: vincularNovoAtivo.value
                      ? undefined
                      : ativo?.patrimonio == undefined ||
                        ativo?.patrimonio == null
                      ? undefined
                      : ativo?.ativoFinal?.patrimonio != ativo?.patrimonio
                      ? ativo?.patrimonio
                      : undefined,
                    preco: vincularNovoAtivo.value
                      ? undefined
                      : ativo?.valor == undefined || ativo?.valor == null
                      ? undefined
                      : ativo?.ativoFinal?.preco != parseFloat(ativo?.valor)
                      ? parseFloat(ativo?.valor)
                      : undefined,
                    valorLocacao: vincularNovoAtivo.value
                      ? undefined
                      : ativo?.valorLocacao == undefined ||
                        ativo?.valorLocacao == null
                      ? undefined
                      : ativo?.ativoFinal?.valorLocacao !=
                        parseFloat(ativo?.valorLocacao)
                      ? parseFloat(ativo?.valorLocacao)
                      : undefined,
                    documentoTipo: vincularNovoAtivo.value
                      ? undefined
                      : documentoTipo?.value?.value == undefined ||
                        documentoTipo?.value?.value == null ||
                        documentoTipo?.value?.value == ""
                      ? undefined
                      : ativo?.ativoFinal?.documentoTipo !=
                        documentoTipo?.value?.value
                      ? documentoTipo?.value?.value
                      : undefined,
                    documentoSerie: vincularNovoAtivo.value
                      ? undefined
                      : dados.value.documentoSerie == undefined ||
                        dados.value.documentoSerie == null ||
                        dados.value.documentoSerie == ""
                      ? undefined
                      : ativo?.ativoFinal?.documentoSerie !=
                        dados.value.documentoSerie
                      ? dados.value.documentoSerie
                      : undefined,
                    documentoNumero: vincularNovoAtivo.value
                      ? undefined
                      : dados.value.numero == undefined ||
                        dados.value.numero == null ||
                        dados.value.numero == ""
                      ? undefined
                      : ativo?.ativoFinal?.documentoNumero !=
                        dados.value.numero.toString()
                      ? dados.value.numero.toString()
                      : undefined,
                    documentoEmissao: vincularNovoAtivo.value
                      ? undefined
                      : dataEmissao.value.split("/").reverse().join("-") ==
                          undefined ||
                        dataEmissao.value.split("/").reverse().join("-") ==
                          null ||
                        dataEmissao.value.split("/").reverse().join("-") == ""
                      ? undefined
                      : ativo?.ativoFinal?.documentoEmissao !=
                        dataEmissao.value.split("/").reverse().join("-")
                      ? dataEmissao.value.split("/").reverse().join("-")
                      : undefined,
                    tempoPermanencia: vincularNovoAtivo.value
                      ? undefined
                      : ativo?.tempoPermanencia == undefined ||
                        ativo?.tempoPermanencia == null
                      ? undefined
                      : ativo?.ativoFinal?.tempoPermanencia !=
                        parseFloat(ativo?.tempoPermanencia)
                      ? parseFloat(ativo?.tempoPermanencia)
                      : undefined,
                  }
                : ativo?.ativoFinal == undefined
                ? {
                    patrimonio: vincularNovoAtivo.value
                      ? undefined
                      : ativo?.patrimonio == undefined ||
                        ativo?.patrimonio == null
                      ? undefined
                      : ativo?.patrimonio != ativo?.patrimonioInicial
                      ? ativo?.patrimonio
                      : undefined,
                    preco: vincularNovoAtivo.value
                      ? undefined
                      : ativo?.valor == undefined || ativo?.valor == null
                      ? undefined
                      : ativo?.valorInicial != ativo?.valor
                      ? parseFloat(ativo?.valor)
                      : undefined,
                    valorLocacao: vincularNovoAtivo.value
                      ? undefined
                      : ativo?.valorLocacao == undefined ||
                        ativo?.valorLocacao == null
                      ? undefined
                      : ativo?.valorLocacaoInicial != ativo?.valorLocacao
                      ? parseFloat(ativo?.valorLocacao)
                      : undefined,
                    tempoPermanencia: vincularNovoAtivo.value
                      ? undefined
                      : ativo?.tempoPermanencia == undefined ||
                        ativo?.tempoPermanencia == null
                      ? undefined
                      : ativo?.tempoPermanenciaInicial !=
                        ativo?.tempoPermanencia
                      ? parseFloat(ativo?.tempoPermanencia)
                      : undefined,
                    documentoTipo: vincularNovoAtivo.value
                      ? undefined
                      : documentoTipo?.value?.value == undefined ||
                        documentoTipo?.value?.value == null ||
                        documentoTipo?.value?.value == ""
                      ? undefined
                      : ativo?.documentoTipo != documentoTipo?.value?.value
                      ? documentoTipo?.value?.value
                      : undefined,
                    documentoSerie: vincularNovoAtivo.value
                      ? undefined
                      : dados.value.documentoSerie == undefined ||
                        dados.value.documentoSerie == null ||
                        dados.value.documentoSerie == ""
                      ? undefined
                      : ativo?.documentoSerie != dados.value.documentoSerie
                      ? dados.value.documentoSerie
                      : undefined,
                    documentoNumero: vincularNovoAtivo.value
                      ? undefined
                      : dados.value.numero.toString() == undefined ||
                        dados.value.numero.toString() == null ||
                        dados.value.numero.toString() == ""
                      ? undefined
                      : ativo?.documentoNumero != dados.value.numero.toString()
                      ? dados.value.numero.toString()
                      : undefined,
                    documentoEmissao: vincularNovoAtivo.value
                      ? undefined
                      : dataEmissao.value.split("/").reverse().join("-") ==
                          undefined ||
                        dataEmissao.value.split("/").reverse().join("-") ==
                          null ||
                        dataEmissao.value.split("/").reverse().join("-") == ""
                      ? undefined
                      : ativo?.documentoEmissao !=
                        dataEmissao.value.split("/").reverse().join("-")
                      ? dataEmissao.value.split("/").reverse().join("-")
                      : undefined,
                  }
                : undefined,
            novoAtivo: ativo?.uuid
              ? {
                  catalogoItemUuid: ativo?.uuid,
                  patrimonio: ativo?.patrimonio || "",
                  tempoPermanencia: parseFloat(ativo?.tempoPermanencia),
                  urlImagem: ativo?.url,
                  preco: parseFloat(ativo?.valor),
                  valorLocacao: parseFloat(ativo?.valorLocacao),
                  origem: ativo?.origem?.value,
                  documentoTipo: documentoTipo?.value?.value || "",
                  documentoSerie: dados.value.documentoSerie,
                  documentoNumero: dados.value.numero.toString(),
                  documentoEmissao: dataEmissao.value
                    .split("/")
                    .reverse()
                    .join("-"),
                  depositoLocalUuid: ativo?.deposito?.depositoLocalUuid,
                  responsavelId: ativo?.responsavel?.id || "",
                  atributos:
                    ativo?.atributos.length > 0
                      ? montarAtributoArray(ativo.atributos)
                      : undefined,
                  acessorios:
                    ativo?.acessorios.length > 0
                      ? montarAcessorioArray(ativo?.acessorios)
                      : undefined,
                  checkLists:
                    ativo?.checkLists.length > 0
                      ? montarChecklistArray(ativo?.checkLists)
                      : undefined,
                }
              : undefined,
          });
        }
      });
      if (selectedAtivos.value.length > 0) {
        selectedAtivos.value.forEach((ativo) => {
          if (ativo?.operacao?.transferenciaOperacaoUuid) {
            ativos.push({
              operacaoUuid: ativo?.operacao?.transferenciaOperacaoUuid,
              statusFinal: ativo?.status || ativo?.statusFinal,
              ativoUuid: ativo?.ativoUuid,
            });
          }
        });
      }
      try {
        ativosErrosIndicatorNew.value = [];
        await store.dispatch("ferramentaria/vincularAtivoTransferencia", {
          transferenciaUuid: transferenciaId,
          ativos,
          usuarioId: store.state.autenticacao.usuarioLogado.id,
          usuarioNome: store.state.autenticacao.usuarioLogado.nome,
        });
        if (!envioTransferencia.value) {
          editarTransferencia();
        }
        if (edicaoAtivo.value) {
          detalharTransferencia();
        }
        vincularNovoAtivo.value = false;
        disableCriacaoAtivo.value = false;
      } catch (error) {
        ativosErrosIndicatorNew.value.push(
          error.response?.data?.erros?.dados?.patrimonio
        );

        if (error.response?.data?.erro?.detalhes?.ativos?.novoAtivo) {
          for (const key in error.response?.data?.erro?.detalhes?.ativos
            ?.novoAtivo) {
            if (
              Object.hasOwnProperty.call(
                error.response?.data?.erro?.detalhes?.ativos?.novoAtivo,
                key
              )
            ) {
              const element =
                error.response?.data?.erro?.detalhes?.ativos?.novoAtivo[key];
              quasar.notify({
                message: `${key}: ${element}`,
                color: "negative",
                actions: [
                  {
                    label: "Fechar",
                    color: "white",
                    handler: () => {
                      /* ... */
                    },
                  },
                ],
              });
            }
          }
        }
        if (error?.response?.data?.erros?.erro) {
          quasar.notify({
            message: error?.response?.data?.erros?.erro,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (
          error.response?.data?.erros?.mensagem !=
            "Erro ao criar ativo, revise os dados e tente novamente." &&
          error.response?.data?.erros?.mensagem
        ) {
          quasar.notify({
            message:
              error.response?.data?.erros?.mensagem ||
              error.response?.data?.erro?.detalhes?.ativos,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }

        if (error.response?.data?.erro?.detalhes?.ativos) {
          for (const key in error.response?.data?.erro?.detalhes?.ativos) {
            if (
              Object.hasOwnProperty.call(
                error.response?.data?.erro?.detalhes?.ativos,
                key
              )
            ) {
              const element = error.response?.data?.erro?.detalhes?.ativos[key];
              quasar.notify({
                message:
                  element == "Nao pode ser vazio ou nulo"
                    ? "Campo operação nao pode estar vazio"
                    : `${key}: ${element}`,
                color: "negative",
                actions: [
                  {
                    label: "Fechar",
                    color: "white",
                    handler: () => {
                      /* ... */
                    },
                  },
                ],
              });
            }
          }
        }
        vincularNovoAtivo.value = false;
        disableCriacaoAtivo.value = false;
      }
    };

    const verificarCampoPreenchido = () => {
      let campoPreenchido = true;
      for (let i = 0; i < selected.value.length; i++) {
        const linha = selected.value[i];
        if (
          linha?.deposito?.depositoLocalUuid == undefined ||
          linha?.deposito?.depositoLocalUuid == ""
        ) {
          quasar.notify({
            message: `Preencha o campo local de deposito do item ${linha.codigo}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          campoPreenchido = false;
        }
        if (linha?.origem?.value == undefined || linha?.origem?.value == "") {
          campoPreenchido = false;
          quasar.notify({
            message: `Preencha o campo origem do item ${linha.codigo}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (
          linha?.origem?.value != "consumo" &&
          (linha?.patrimonio == "" || linha?.patrimonio == undefined)
        ) {
          campoPreenchido = false;
          quasar.notify({
            message: `Preencha o campo patrimonio do item ${linha.codigo}`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (!campoPreenchido) {
          break;
        }
      }
      return campoPreenchido;
    };

    const verificarQuantidadeAtivoMultiplicado = (uuid) => {
      let quantidadeAtivos = [];
      quantidadeAtivos = selected.value.filter(
        (ativo) =>
          ativo.uuid == uuid &&
          (ativo.primario == false || ativo.primario == undefined)
      );
      return quantidadeAtivos;
    };

    const criarListaAtivoSelecionado = (array) => {
      selected.value = [];
      array.forEach((ativo) => {
        selected.value.push({
          ativoUuid: ativo?.ativoFinal?.ativoUuid,
          codigo: ativo?.ativoFinal?.catalogoItem?.codigo,
          descricao: ativo?.ativoFinal?.catalogoItem?.nome,
          operacao: ativo?.operacao,
          status: ativo?.ativoFinal?.status,
          grupo: ativo?.ativoFinal?.catalogoItem?.catalogoGrupo,
          subgrupo: ativo?.ativoFinal?.catalogoItem?.catalogoSubGrupo,
          patrimonio: ativo?.ativoFinal?.patrimonio,
          valor: ativo?.ativoFinal?.preco,
          atributos: ativo?.ativoFinal?.atributos,
          checkLists: ativo?.ativoFinal?.checkLists,
          acessorios: ativo?.ativoFinal?.acessorios,
          urlImagem: ativo?.ativoFinal?.urlImagem,
          deposito: ativo?.ativoFinal?.deposito?.local,
          origem: ativo?.ativoFinal?.origem,
          ativoInicial: ativo?.ativoInicial,
          valorLocacao: ativo?.ativoFinal.valorLocacao,
          tempoPermanencia: ativo?.ativoFinal.tempoPermanencia,
          ativoFinal: ativo?.ativoFinal,
          rejeitado: ativo?.rejeitado,
          respostasAcessorioEnvio: ativo?.respostasAcessorioEnvio,
          respostasAcessorioRecebimento: ativo?.respostasAcessorioRecebimento,
          respostasChecklistEnvio: ativo?.respostasChecklistEnvio,
          respostasChecklistRecebimento: ativo?.respostasChecklistRecebimento,
        });
        if (ativo?.rejeitado == "sim") {
          selectedRejeitados.value.push({
            ativoUuid: ativo?.ativoFinal?.ativoUuid,
            codigo: ativo?.ativoFinal?.catalogoItem?.codigo,
            descricao: ativo?.ativoFinal?.catalogoItem?.nome,
            operacao: ativo?.operacao,
            status: ativo?.ativoFinal?.status,
            grupo: ativo?.ativoFinal?.catalogoItem?.catalogoGrupo,
            subgrupo: ativo?.ativoFinal?.catalogoItem?.catalogoSubGrupo,
            patrimonio: ativo?.ativoFinal?.patrimonio,
            valor: ativo?.ativoFinal?.preco,
            atributos: ativo?.ativoFinal?.atributos,
            checkLists: ativo?.ativoFinal?.checkLists,
            acessorios: ativo?.ativoFinal?.acessorios,
            urlImagem: ativo?.ativoFinal?.urlImagem,
            valorLocacao: ativo?.ativoFinal.valorLocacao,
            deposito: ativo?.ativoFinal?.deposito?.local,
            tempoPermanencia: ativo?.ativoFinal.tempoPermanencia,
            origem: ativo?.ativoFinal?.origem,
            ativoInicial: ativo?.ativoInicial,
            ativoFinal: ativo?.ativoFinal,
            rejeitado: ativo?.rejeitado,
            respostasAcessorioEnvio: ativo?.respostasAcessorioEnvio,
            respostasAcessorioRecebimento: ativo?.respostasAcessorioRecebimento,
            respostasChecklistEnvio: ativo?.respostasChecklistEnvio,
            respostasChecklistRecebimento: ativo?.respostasChecklistRecebimento,
          });
        }
        if (ativo?.rejeitado == "nao") {
          selectedRecebidos.value.push({
            ativoUuid: ativo?.ativoFinal?.ativoUuid,
            codigo: ativo?.ativoFinal?.catalogoItem?.codigo,
            descricao: ativo?.ativoFinal?.catalogoItem?.nome,
            operacao: ativo?.operacao,
            status: ativo?.ativoFinal?.status,
            grupo: ativo?.ativoFinal?.catalogoItem?.catalogoGrupo,
            subgrupo: ativo?.ativoFinal?.catalogoItem?.catalogoSubGrupo,
            patrimonio: ativo?.ativoFinal?.patrimonio,
            valor: ativo?.ativoFinal?.preco,
            atributos: ativo?.ativoFinal?.atributos,
            checkLists: ativo?.ativoFinal?.checkLists,
            acessorios: ativo?.ativoFinal?.acessorios,
            urlImagem: ativo?.ativoFinal?.urlImagem,
            valorLocacao: ativo?.ativoFinal.valorLocacao,
            deposito: ativo?.ativoFinal?.deposito?.local,
            tempoPermanencia: ativo?.ativoFinal.tempoPermanencia,
            origem: ativo?.ativoFinal?.origem,
            ativoInicial: ativo?.ativoInicial,
            ativoFinal: ativo?.ativoFinal,
            rejeitado: ativo?.rejeitado,
            respostasAcessorioEnvio: ativo?.respostasAcessorioEnvio,
            respostasAcessorioRecebimento: ativo?.respostasAcessorioRecebimento,
            respostasChecklistEnvio: ativo?.respostasChecklistEnvio,
            respostasChecklistRecebimento: ativo?.respostasChecklistRecebimento,
          });
        }
      });
      if (tab.value == "criarAtivo" && selectedAtivos.value.length > 0) {
        selectedAtivos.value.forEach((ativo) => {
          dados.value?.status === "criada"
            ? selected.value.push({
                ativoUuid: ativo?.ativo?.ativoUuid,
                codigo: ativo?.ativo?.codigo,
                descricao: ativo?.ativo?.nome,
                operacao: ativo?.operacao,
                status: ativo?.ativo?.status,
                grupo: ativo?.ativo.catalogoGrupo,
                subgrupo: ativo?.ativo?.catalogoSubGrupo,
                patrimonio: ativo?.ativo?.patrimonio,
                preco: ativo?.ativo?.preco,
                atributos: ativo?.ativo?.atributos,
                checkLists: ativo?.ativo?.checkLists,
                acessorios: ativo?.ativo?.acessorios,
                urlImagem: ativo?.ativo?.urlImagem,
                deposito: ativo.ativo?.deposito?.local,
              })
            : ativosAdicionadosTransferencia.value.push({
                ativoUuid: ativo?.ativo?.ativoUuid,
                codigo: ativo?.ativo?.codigo,
                descricao: ativo?.ativo?.nome,
                operacao: ativo?.operacao,
                status: ativo?.ativo?.status,
                grupo: ativo?.ativo.catalogoGrupo,
                subgrupo: ativo?.ativo?.catalogoSubGrupo,
                patrimonio: ativo?.ativo?.patrimonio,
                preco: ativo?.ativo?.preco,
                atributos: ativo?.ativo?.atributos,
                checkLists: ativo?.ativo?.checkLists,
                acessorios: ativo?.ativo?.acessorios,
                urlImagem: ativo?.ativo?.urlImagem,
                deposito: ativo.ativo?.deposito?.local,
              });
        });
        tab.value = "selecionarAtivo";
        criarAtivoCatalogo.value = false;
      }
      atualizarListaCards.value++;
    };

    const editarTransferencia = async () => {
      try {
        await store.dispatch("ferramentaria/editarTransferencia", {
          transferenciaUuid: transferenciaId,
          pedido: transferencia.value?.pedido,
          solicitacaoCompra: transferencia.value?.solicitacaoCompra,
          documentoTipo:
            dados.value?.documentoTipo?.value || dados.value?.documentoTipo,
          documentoSerie: dados.value?.documentoSerie,
          documentoNumero: dados.value?.documentoNumero?.toString(),
          observacao: observacao.value.replace(new RegExp("\\n", "gi"), " "),
          documentoEmissao: dataEmissao.value?.split("/")?.reverse()?.join("-"),
          solicitante: {
            nome: envioTransferencia.value
              ? dadosTransferencia.value?.solicitante?.nome || "Não Informado"
              : dadosTransferencia.value?.solicitante?.nome,
            matricula: envioTransferencia.value
              ? dadosTransferencia.value?.solicitante?.matricula ||
                "Não Informado"
              : dadosTransferencia.value?.solicitante?.matricula,
            funcionario: dadosTransferencia.value?.solicitante?.funcionario,
          },
          expedidor: {
            nome: envioTransferencia.value
              ? dadosTransferencia.value?.expedidor?.nome || "Não Informado"
              : dadosTransferencia.value?.expedidor?.nome,
            matricula: envioTransferencia.value
              ? dadosTransferencia.value?.expedidor?.matricula ||
                "Não Informado"
              : dadosTransferencia.value?.expedidor?.matricula,
            funcionario: dadosTransferencia.value?.expedidor?.funcionario,
          },
          transportador: {
            nome: envioTransferencia.value
              ? dadosTransferencia.value?.transportador?.nome || "Não Informado"
              : dadosTransferencia.value?.transportador?.nome,
            documento: envioTransferencia.value
              ? dadosTransferencia.value?.transportador?.documento ||
                "Não Informado"
              : dadosTransferencia.value?.transportador?.documento,
            placaVeiculo: envioTransferencia.value
              ? dadosTransferencia.value?.transportador?.placa ||
                "Não Informado"
              : dadosTransferencia.value?.transportador?.placa,
            modeloVeiculo: envioTransferencia.value
              ? dadosTransferencia.value?.transportador?.veiculo ||
                "Não Informado"
              : dadosTransferencia.value?.transportador?.veiculo,
            funcionario: dadosTransferencia.value?.transportador?.funcionario,
            observacao: envioTransferencia.value
              ? dadosTransferencia.value?.transportador?.observacao ||
                "Não Informado"
              : dadosTransferencia.value?.transportador?.observacao,
          },
        });
        if (!envioTransferencia.value) {
          detalharTransferencia();
          quasar.notify({
            message: "Transferência salva com sucesso.",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        tab.value = "selecionarAtivo";
        criarAtivoCatalogo.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const montarChecklistArray = (arrayChecklist) => {
      let array = [];
      arrayChecklist.forEach((checklist) => {
        array.push({
          checkListUuid: checklist.checkListUuid,
        });
      });
      return array;
    };

    const montarAcessorioArray = (arrayAcessorio) => {
      let array = [];
      arrayAcessorio.forEach((acessorio) => {
        if (acessorio.uuid) {
          array.push({
            acessorioUuid: acessorio.uuid,
          });
        } else {
          array.push({
            nome: acessorio.nome,
          });
        }
      });
      return array;
    };

    const montarAtributoArray = (arrayAtributo) => {
      let array = [];
      arrayAtributo.forEach((atributo) => {
        array.push({
          chave: atributo.chave,
          valor: atributo.valor,
        });
      });
      return array;
    };

    const receberFuncionarioSolicitante = (value) => {
      if (value === null) {
        dadosTransferencia.value.solicitante.nome = "";
        dadosTransferencia.value.solicitante.matricula = "";
        return;
      }
      dadosTransferencia.value.solicitante.nome = value.nome;
      dadosTransferencia.value.solicitante.matricula = value.id;
    };

    const receberFuncionarioExpedidor = (value) => {
      if (value === null) {
        dadosTransferencia.value.expedidor.nome = "";
        dadosTransferencia.value.expedidor.matricula = "";
        return;
      }
      dadosTransferencia.value.expedidor.nome = value.nome;
      dadosTransferencia.value.expedidor.matricula = value.id;
    };
    const receberSolicitanteAutenticar = (value) => {
      if (value === null) {
        dadosTransferencia.value.solicitanteAutenticar.nome = "";
        dadosTransferencia.value.solicitanteAutenticar.matricula = "";
        dadosTransferencia.value.solicitanteAutenticar.id = "";
        return;
      }

      dadosTransferencia.value.solicitanteAutenticar.id = value.idTabela;
      dadosTransferencia.value.solicitanteAutenticar.nome = value.nome;
      dadosTransferencia.value.solicitanteAutenticar.matricula = value.id;
    };

    const receberFuncionarioTransportador = (value) => {
      if (value === null) {
        dadosTransferencia.value.transportador.nome = "";
        dadosTransferencia.value.transportador.documento = "";
        return;
      }
      dadosTransferencia.value.transportador.nome = value.nome;
      dadosTransferencia.value.transportador.documento = value.id;
    };

    const receberConfiguracoesSetup = () => {
      if (configuracoesSetup.dadoSetupAutenticacao.value.length === 0) {
        return;
      }
      let array = configuracoesSetup.dadoSetupAutenticacao.value.filter(
        (setup) => setup.etapa === props.tipoTransferencia
      );
      metodoAutenticacao.value = array[0].autenticacao;

      respostas.value = {
        responderCheckLists: array[0].responderCheckLists,
        responderAcessorios: array[0].responderAcessorios,
      };
    };

    const recebeBiometria = async (value) => {
      base64Biometria.value = value;
    };

    const receberResultadoBiometria = (value) => {
      biometriaVerificacao.value = value;
    };

    const listarItensCatalogo = async (page = 1, perPage = 10, ordenacao = { nome: "desc" } ) => {
      if (dados.value.status != "criada") {
        return;
      }
      loading.value = true;
      disable.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarFerramentas",
          {
            ordenacao:ordenacao,
            perPage: perPage,
            page: page,
            unidadeId: transferencia.value.destino.id,
            comAcessorios: "sim",
            comAtributos: "sim",
            comCheckLists: "sim",
            codigo: filtros.value?.codigo,
            nome: filtros.value?.descricao,
            catalogoUuid: catalogoUuid.catalogoUuid.value,
            catalogoSubGrupoUuid: filtros.value.subgrupo?.catalogoSubGrupoUuid,
            nomeGrupo: filtros.value?.grupo?.nome,
            nomeSubgrupo: filtros.value?.grupo?.nome
              ? filtros.value?.subgrupo?.nome
              : "",
          }
        );
        listaItensCatalogo.value = response.listaFerramentas;
        pagination.value.page = response.response.data.resultado.currentPage;
        pagination.value.rowsPerPage = response.response.data.resultado.perPage;
        pagination.value.rowsNumber = response.response.data.resultado.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const salvarAlteracoesItem = (value) => {
      if (criarAtivoCatalogo.value) {
        let index = selected.value.findIndex((item) => item.uuid == value.uuid);
        selected.value.splice(index, 1, value);
        return;
      }
      let index = selected.value.findIndex(
        (item) => item.ativoUuid == value.ativoUuid
      );
      selected.value.splice(index, 1, value);
    };

    const verificarChecklist = (checklist) => {
      let valido = checklist.every(
        (value) => value.resposta === "sim" || value.resposta === "nao"
      );
      if (!valido) {
        return undefined;
      }
      let array = [];
      checklist.forEach((value) => {
        array.push({
          checkListUuid: value.checkListUuid,
          resposta: value.resposta,
        });
      });
      return array;
    };

    const verificarAcessorio = (acessorios) => {
      let valido = acessorios.every(
        (value) => value.resposta === "sim" || value.resposta === "nao"
      );
      if (!valido) {
        return undefined;
      }
      let array = [];
      acessorios.forEach((value) => {
        array.push({
          acessorioUuid: value.uuid,
          resposta: value.resposta,
        });
      });
      return array;
    };

    const verificarTipoRecebimento = async () => {
      if (receberTodosAtivos.value) {
        if (metodoSelected.value == "assinatura") {
          salvarAssinatura.value++;
        }
        setTimeout(() => {
          receberTransferencia();
        }, 1000);

        return;
      }
      rightDrawerOpenRejeitar.value = true;
    };

    const salvarAlteracoesSelecionado = (array) => {
      selected.value = [...array];
    };

    const verificarStatus = () => {
      if (dados.value.status == "criada") {
        rightDrawerOpen.value = true;
        return;
      }
      verificarTipoRecebimento();
    };

    const removerItemCriacao = (uuid, primario, index) => {
      if (primario) {
        selected.value = selected.value.filter((dado) => dado.uuid != uuid);
        return;
      }
      selected.value.splice(index, 1);
      atualizarSelecionado.value++;
    };

    const adicicionarItem = (item) => {
      let index = selected.value.findIndex((dado) => dado.uuid == item.uuid);
      if (index != -1) {
        removerItemCriacao(item.uuid, true);
        return;
      }
      selected.value.push({
        primario: true,
        acessorios: item.acessorios,
        atributos: item.atributos,
        checkLists: item.checkLists,
        codigo: item.codigo,
        depositoLocalUuid: item.depositoLocalUuid,
        descricao: item.descricao,
        grupo: item.grupo,
        subgrupo: item.subgrupo,
        tempoPermanencia: item.tempoPermanencia,
        unidadeMedida: item.unidadeMedida,
        url: item.url,
        uuid: item.uuid,
      });
      atualizarSelecionado.value++;
    };

    const resetarRejeitados = () => {
      ativosRejeitar.value = [...ativosSelecionadosRejeitar.value];
      alterarRejeitados.value = true;
    };

    watch(
      () => transferencia.value?.origem?.id,
      () => {
        listarAtivos();
      }
    );

    watch(
      () => configuracoesSetup.dadoSetupAutenticacao.value,
      () => {
        receberConfiguracoesSetup();
      }
    );

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (!rightDrawerOpen.value) {
          envioTransferencia.value = false;
        }
      }
    );

    watch(
      () => rightDrawerOpenRejeitar.value,
      () => {
        if (!rightDrawerOpenRejeitar.value && alterarRejeitados.value) {
          return;
        }
        ativosRejeitar.value = [...ativosSelecionadosRejeitar.value];
        alterarRejeitados.value = false;
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        if (tab.value == "criarAtivo") {
          listarItensCatalogo(
            pagination.value.page,
            pagination.value.rowsPerPage
          );
          return;
        }
        listarAtivos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => tab.value,
      () => {
        filtros.value = {};
        if (tab.value == "criarAtivo") {
          criarAtivoCatalogo.value = true;
          selectedAtivos.value = [...selected.value];
          selected.value = [];
          listaAtivos.value = [];
          listarItensCatalogo();
        } else {
          criarAtivoCatalogo.value = false;
          listaItensCatalogo.value = [];
          selected.value = [...selectedAtivos.value];
          listarAtivos();
        }
      }
    );

    const receberAssinatura = async (assinatura) => {
      assinaturaBase64.value = await assinatura;

      if (dados.value.status == "criada") {
        verificarDadosAdicionados();
      }
    };

    const enviarBase64S3 = async (tipoImagem) => {
      file.value = converterBase64Arquivo(
        tipoImagem == "assinatura"
          ? assinaturaBase64.value.split("base64,")[1]
          : base64Biometria.value,
        tipoImagem,
        "image/png"
      );

      try {
        const response = await store.dispatch(
          "ferramentaria/buscarUrlEmprestimoAutenticacao",
          {
            nomeArquivo: file.value.name,
          }
        );
        formAttributes.value = response.data.resultado.dados.formAttributes;
        formInputs.value = response.data.resultado.dados.formInputs;
        const formData = new FormData();

        for (let input in formInputs.value) {
          formData.append(input, formInputs.value[input]);
        }
        formData.append("file", file.value);
        var request = new XMLHttpRequest();
        request.open(formAttributes.value.method, formAttributes.value.action);
        request.send(formData);

        base64.value = null;
      } catch (error) {
        console.log(error);
      }
    };

    const converterBase64Arquivo = (base64String, nomeArquivo, mimeType) => {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: mimeType });

      const file = new File([blob], nomeArquivo, { type: mimeType });
      return file;
    };

    const verificarPinSolicitante = async () => {
      if (pin.value == "") {
        quasar.notify({
          message: "O campo não pode estar vazio",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        disable.value = false;
        return;
      }
      try {
        const response = await store.dispatch("requisicao/checarPin", {
          pin: pin.value,
          user_id: store.state.autenticacao.idBase,
        });
        if (response.data.result.pin_correto) {
          pin.value = "";
          disable.value = false;
          return true;
        } else {
          quasar.notify({
            message: "PIN digitado, não corresponde ao pin do usuário!",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          disable.value = false;
          return false;
        }
      } catch (error) {
        quasar.notify({
          message: "Erro ao validar pin",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };
    onMounted(async () => {
      await detalharTransferencia();
      receberConfiguracoesSetup();
      if (dados.value.status === "criada") {
        listarAtivos();
        return;
      }
    });
    const handleRequest = async (value) => {
      const ordenacao = {};
      
      if (valorOrdenacao.value == value.pagination.sortBy) {
        igual.value = !igual.value;
        ordenacao[valorOrdenacao.value == 'descricao' ? 'nome' :valorOrdenacao.value] = igual.value ? "asc" : "desc";

        pagination.value.sortBy = valorOrdenacao.value;
        pagination.value.descending = igual.value ? false : true;

        if (tab.value == "criarAtivo") {
          listarItensCatalogo(
            pagination.value.page,
            pagination.value.rowsPerPage,
            ordenacao
          );
          return;
        }
        listarAtivos(pagination.value.page, pagination.value.rowsPerPage, ordenacao);
        return;
      }

      igual.value = false;

      valorOrdenacao.value = value.pagination.sortBy;
      pagination.value.sortBy = valorOrdenacao.value;
      pagination.value.descending = true;

      ordenacao[
      valorOrdenacao.value == 'descricao' ? 'nome' :valorOrdenacao.value
      ] = "desc";
  
      if (tab.value == "criarAtivo") {
          listarItensCatalogo(
            pagination.value.page,
            pagination.value.rowsPerPage,
            ordenacao
          );
          return;
        }
        listarAtivos(pagination.value.page, pagination.value.rowsPerPage, ordenacao);
    };
    return {
      handleRequest,
      columns,
      columnsItemSelecionado,
      columnsRejeitar,
      tab,
      columnsItem,
      recebeBiometria,
      metodoSelected,
      verificarPinSolicitante,
      transferenciaId,
      dados,
      ativosSelecionadosRejeitar,
      editarItemCatalogo,
      detalharTransferencia,
      salvarAlteracoesSelecionado,
      verificarTipoRecebimento,
      alterarRejeitados,
      resetarRejeitados,
      adicicionarItem,
      ativosAdicionadosTransferencia,
      listaAtivos,
      receberFiltro,
      receberTodosAtivos,
      vincularNovoAtivo,
      receberCatalogoEspecifico,
      verificarStatus,
      selectedRejeitados,
      listarAtivos,
      edicaoAtivo,
      selected,
      verificarChecklist,
      verificarAcessorio,
      selectStatus,
      selectedRecebidos,
      selectedAtivos,
      loading,
      resetarChecklist,
      disableCriacaoAtivo,
      selectOperacao,
      enviarTransferencia,
      salvarAlteracoesItem,
      options,
      dataValida,
      disable,
      rightDrawerOpen,
      rightDrawerOpenRejeitar,
      dadosTransferencia,
      envioTransferencia,
      dadosTransferenciaPreenchidos,
      atualizarListaCards,
      enviandoTransfencia,
      dataEmissao,
      removerItem,
      validarRespostas,
      ativosLista,
      ativosRejeitar,
      filtros,
      respostas,
      listaItensCatalogo,
      rightDrawerOpenDetalheAtivo,
      rightDrawerOpenDetalheItem,
      receberAssinatura,
      salvarAssinatura,
      biometriaModal,
      dadoAtributo,
      verificarQuantidadeAtivoMultiplicado,
      verificarDadosAdicionados,
      catalogoEspecificoUuid,
      receberFuncionarioSolicitante,
      transferencia,
      verificarRepostaCriacaoAtivo,
      confirmRejeitar,
      ativosErrosIndicatorNew,
      metodoAutenticacao,
      pin,
      receberTransferencia,
      validacaodata(date) {
        let hoje = new Date();
        let ontem = new Date(hoje.getTime());
        ontem.setDate(hoje.getDate());
        let dd = ontem.getDate();
        let mm = ontem.getMonth() + 1;
        let yyyy = ontem.getFullYear();
        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }
        let data_valida = yyyy + "/" + mm + "/" + dd;
        dataValida = data_valida;

        return date <= data_valida;
      },
      receberFuncionarioExpedidor,
      receberFuncionarioTransportador,
      rightDrawerPessoas,
      quasar,
      resetFuncionarioSolicitante,
      resetFuncionarioExpedidor,
      modalHistorico,
      observacao,
      resetFuncionarioTransportador,
      mobile,
      removerItemCriacao,
      pagination,
      receberConfiguracoesSetup,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      configuracoesSetup,
      criarAtivoCatalogo,
      catalogoUuid,
      selectedItens,
      documentoTipo,
      recebendoTransferencia,
      editarTransferencia,
      vincularAtivoTransferencia,
      receberResultadoBiometria,
      biometriaVerificacao,
      usuarioBiometria,
      criarListaAtivoSelecionado,
      salvarAtivoCriado,
      montarAcessorioArray,
      montarChecklistArray,
      montarAtributoArray,
      verificarCampoPreenchido,
      listaAnexo,
      atualizarSelecionado,
      atualizarRejeitados,
      receberSolicitanteAutenticar,
      isTransferenciaExterna,
      possuiAtivoLocado,
      verificarAtivosLocados,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
tbody tr td {
  white-space: pre-wrap;
}
.icon {
  cursor: pointer;
}
.texto-modal-pessoa {
  font-size: 15px;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.tabela-modal-rejeitar tbody tr td {
  white-space: pre-wrap;
}
.card {
  border: 1px solid #707070;
  border-radius: 5px;
}
.text-grid-table {
  font-size: 15px;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
.titulo-tabela {
  font-size: 18px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.texto-titulo-modal {
  font-size: 16px;
}
.texto-titulo-input-modal {
  font-size: 15px;
}
.container-modal-excluir {
  width: 590px;
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1024px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
  .sem-margin {
    margin-left: 0px;
    margin-top: 5px;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .texto-modal-pessoa {
    font-size: 15px;
  }
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
  .sem-margin {
    margin-left: 0px;
    margin-top: 5px;
  }
  .input {
    font-size: 12px;
  }
  .btn-imprimir {
    margin-top: 0px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .texto-titulo-modal {
    font-size: 14px;
  }
  .texto-titulo-input-modal {
    font-size: 13px;
  }
  .input-radio {
    font-size: 12px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .btn-modal {
    font-size: 12px;
  }
  .btn {
    font-size: 13px;
  }
  .btn-enviada {
    font-size: 12px;
  }
  .input-select-grid {
    font-size: 10px;
  }
  .sem-margin {
    margin-left: 0px;
  }
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .btn-excluir {
    font-size: 14px;
  }
}
</style>
